/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import {
  CForm, CRow, CCol, CFormInput, CFormLabel, CFormTextarea,
  CButton, CSpinner, CAlert, CTable, CTableHead,
  CTableRow, CTableHeaderCell, CTableBody, CTableDataCell,
  CCard, CCardBody, CCardHeader, CNav, CNavItem, CNavLink,
  CTabContent, CTabPane, CInputGroup, CModal, CModalHeader,
  CModalTitle, CModalBody, CModalFooter, CBadge
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSave, cilX, cilPlus, cilMinus, cilColorPalette, cilGrid, cilImage } from '@coreui/icons';
import PropTypes from 'prop-types';
import { useTranslation } from '../../hooks/useTranslation';
import {
  getWeaveDropdown,
  getWeaveColors,
  getWeaveFactors,
  createColor,
  createComposition,
  createWeaveType,
  createYarn
} from '../../services/endpoints';
import './WeaveInputs.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getColorRequestAction } from '../../store/color/colorActions';
import { formatDateOnly } from '../../helpers/dateHelper';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import Cropper from 'react-easy-crop';
import { CFormSelect } from '@coreui/react';

const WEAVE_INPUTS_BUILD_MARK = 'weave-photo-fix-2026-03-24-1415';

const WeaveInputs = ({
  onSubmit, onCancel, isLoading = false,
  submitResponse = null, initialData = null, isEdit = false
}) => {
  const { t } = useTranslation();
  const armureFileInputRef = useRef(null);
  const weaveFileInputRef = useRef(null);
  const cropTargetFieldRef = useRef('photo');
  const latestImagesRef = useRef({ photo: '', photoWeave: '' });

  const [formData, setFormData] = useState({
    weaveCode: '',
    description: '',
    warpDensity: '',
    weftDensity: '',
    reedWidth: '',
    reedNo: '',
    dgts: '',
    totalThreads: '',
    prdCompositionGuid: '',
    prdWeaveTypeGuid: '',
    fabricWidth: '',
    fabricWeight: '',
    photo: '',
    photoWeave: ''
  });
  const [totalThreadsEditedByUser, setTotalThreadsEditedByUser] = useState(false);

  const [densityInputs, setDensityInputs] = useState({
    warpDensityWhole: '',
    warpDensityDecimal: '',
    weftDensityWhole: '',
    weftDensityDecimal: ''
  });

  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviewWeave, setImagePreviewWeave] = useState(null);
  const [imageModal, setImageModal] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState(null);
  const [imageModalTitle, setImageModalTitle] = useState('');
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState(null);
  const [cropTargetField, setCropTargetField] = useState('photo');
  const [weaveCropPresetKey, setWeaveCropPresetKey] = useState('square400');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [cropSkipped, setCropSkipped] = useState(false);
  const [manualCropArea, setManualCropArea] = useState(null);
  const [isDraggingHandle, setIsDraggingHandle] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const manualCropCanvasRef = useRef(null);
  const cropImageRef = useRef(null);
  const [dropdownData, setDropdownData] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);

  // Separate table data for warp (çözgü) and weft (atkı)
  const [warpTableData, setWarpTableData] = useState([]);
  const [weftTableData, setWeftTableData] = useState([]);
  const [warpTableColumns, setWarpTableColumns] = useState(1);
  const [weftTableColumns, setWeftTableColumns] = useState(1);

  // Bulk add inputs
  const [bulkAddRows, setBulkAddRows] = useState({ warp: 1, weft: 1 });
  const [bulkAddColumns, setBulkAddColumns] = useState({ warp: 1, weft: 1 });

  const [loadingWeaveColors, setLoadingWeaveColors] = useState(false);
  const [activeTab, setActiveTab] = useState('cozgu');
  const [showWeaveFactorModal, setShowWeaveFactorModal] = useState(false);
  const [weaveFactorModalLoading, setWeaveFactorModalLoading] = useState(false);
  const [weaveFactorModalError, setWeaveFactorModalError] = useState('');
  const [weaveFactorRows, setWeaveFactorRows] = useState([]);
  const [loadedWeaveFactorRowsByThreadType, setLoadedWeaveFactorRowsByThreadType] = useState({
    1: [],
    2: []
  });
  const [pendingWeaveFactorRowsByThreadType, setPendingWeaveFactorRowsByThreadType] = useState({
    1: null,
    2: null
  });
  const [showAddColorModal, setShowAddColorModal] = useState(false);
  const [showAddYarnModal, setShowAddYarnModal] = useState(false);
  const [showAddCompositionModal, setShowAddCompositionModal] = useState(false);
  const [showAddWeaveTypeModal, setShowAddWeaveTypeModal] = useState(false);
  const [addColorLoading, setAddColorLoading] = useState(false);
  const [addYarnLoading, setAddYarnLoading] = useState(false);
  const [addCompositionLoading, setAddCompositionLoading] = useState(false);
  const [addWeaveTypeLoading, setAddWeaveTypeLoading] = useState(false);
  const [addColorForm, setAddColorForm] = useState({
    colorName: '',
    colorCode: '',
    colorDescription: ''
  });
  const [addYarnForm, setAddYarnForm] = useState({
    yarnCode: '',
    yarnName: '',
    yarnType: '',
    yarnDescription: ''
  });
  const [addCompositionForm, setAddCompositionForm] = useState({
    threadName: '',
    threadDescription: ''
  });
  const [addWeaveTypeForm, setAddWeaveTypeForm] = useState({
    weaveTypeName: '',
    weaveTypeDescription: ''
  });
  const [addColorErrors, setAddColorErrors] = useState({});
  const [addYarnErrors, setAddYarnErrors] = useState({});
  const [addCompositionErrors, setAddCompositionErrors] = useState({});
  const [addWeaveTypeErrors, setAddWeaveTypeErrors] = useState({});
  const [quickCreateFeedback, setQuickCreateFeedback] = useState({ type: '', message: '' });

  const cropPresets = {
    square400: { width: 400, height: 400, aspect: 1, label: '400x400' },
    wide350x200: { width: 350, height: 200, aspect: 350 / 200, label: '350x200' }
  };

  const activeCropPreset = cropTargetField === 'photoWeave'
    ? cropPresets[weaveCropPresetKey] || cropPresets.square400
    : cropPresets.square400;

  const dispatch = useDispatch();
  const colorList = useSelector(
    state => state.color?.colorList || state.colorReducer?.colorList || []
  );

  const yarnTypeOptions = [
    { value: '1', label: t('yarnTypeNe') || 'Ne' },
    { value: '2', label: t('yarnTypeNm') || 'Nm' },
    { value: '3', label: t('yarnTypeDny') || 'Dny' }
  ];

  const refreshWeaveDropdownData = async (filters = {}) => {
    setLoadingDropdowns(true);
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...filters };

    try {
      const { data } = await getWeaveDropdown(payload);
      setDropdownData(data || {});
    } catch (err) {
      setDropdownData({});
    } finally {
      setLoadingDropdowns(false);
    }
  };

  const handleDropdownSearch = async (fieldName, searchTerm) => {
    const trimmedSearchTerm = searchTerm?.trim() || '';
    if (trimmedSearchTerm.length > 0 && trimmedSearchTerm.length < 3) return;

    if (fieldName === 'prdCompositionGuid') {
      await refreshWeaveDropdownData({ CompositionSearchTerm: trimmedSearchTerm });
      return;
    }

    if (fieldName === 'prdWeaveTypeGuid') {
      await refreshWeaveDropdownData({ WeaveTypeSearchTerm: trimmedSearchTerm });
    }
  };

  const getCurrentThreadType = () => (activeTab === 'cozgu' ? 2 : 1);

  const createEmptyWeaveFactorRow = (threadType) => ({
    localId: `${Date.now()}-${Math.random()}`,
    weaveFactorId: '',
    threadType,
    firstColon: '',
    secondColon: '',
    factor: ''
  });

  const normalizeWeaveFactorRowsFromApi = (items, threadType) => {
    if (!Array.isArray(items)) return [createEmptyWeaveFactorRow(threadType)];

    const filtered = items.filter(item => Number(item?.ThreadType) === Number(threadType));
    if (filtered.length === 0) return [createEmptyWeaveFactorRow(threadType)];

    return filtered.map((item, idx) => ({
      localId: `${Date.now()}-${idx}-${Math.random()}`,
      weaveFactorId: item?.WeaveFactorId || '',
      threadType,
      firstColon: item?.FirstColon ?? '',
      secondColon: item?.SecondColon ?? '',
      factor: item?.Factor ?? ''
    }));
  };

  const getEffectiveWeaveFactorRowsByThreadType = (threadType) => {
    const pendingRows = pendingWeaveFactorRowsByThreadType?.[threadType];
    if (Array.isArray(pendingRows)) return pendingRows;
    return loadedWeaveFactorRowsByThreadType?.[threadType] || [];
  };

  const getFactorRowsForThreadType = (threadType, includeColors = false) => {
    const rows = getEffectiveWeaveFactorRowsByThreadType(threadType);
    const colorPalette = ['#fff59d', '#c8e6c9'];

    return rows
      .map((row, idx) => {
        const start = Number(row?.firstColon);
        const end = Number(row?.secondColon);
        const factor = Number(row?.factor);

        if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(factor)) return null;
        if (start <= 0 || end <= 0 || start > end || factor <= 0) return null;

        const parsedRow = {
          start,
          end,
          factor
        };

        if (includeColors) {
          parsedRow.backgroundColor = colorPalette[idx % colorPalette.length];
        }

        return parsedRow;
      })
      .filter(Boolean);
  };

  const getColumnFactorForThreadType = (threadType, columnNo) => {
    const factorRows = getFactorRowsForThreadType(threadType, false);
    const matchedRange = factorRows.find(range => columnNo >= range.start && columnNo <= range.end);

    return matchedRange?.factor || 1;
  };

  const getWeightedRowTotalForThreadType = (row, threadType) => {
    if (!row?.values?.length) return 0;

    return row.values.reduce((sum, value, colIndex) => {
      const threadCount = parseInt(value, 10) || 0;
      const factor = getColumnFactorForThreadType(threadType, colIndex + 1);
      return sum + (threadCount * factor);
    }, 0);
  };

  const round4AwayFromZero = (value) => {
    if (!Number.isFinite(value)) return 0;

    const precision = 10000;
    if (value >= 0) {
      return Math.round((value + Number.EPSILON) * precision) / precision;
    }

    return -Math.round((Math.abs(value) + Number.EPSILON) * precision) / precision;
  };

  const scaleWeightToInt = (rawWeight) => {
    const rounded = round4AwayFromZero(rawWeight);
    const scaled = Math.round(rounded * 10000);

    if (scaled > 2147483647) return 2147483647;
    if (scaled < -2147483648) return -2147483648;

    return scaled;
  };

  const parseNumeric = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  };

  const parseScaledDecimalParts = (value) => {
    if (value === null || value === undefined || value === '') {
      return { whole: '', decimal: '' };
    }

    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return { whole: '', decimal: '' };
    }

    const formatted = (numeric / 100).toFixed(2);
    const [whole, decimal] = formatted.split('.');
    return { whole, decimal: decimal || '00' };
  };

  const toScaledInt = (whole, decimal) => {
    const wholeValue = String(whole || '').replace(/\D/g, '');
    const decimalValue = String(decimal || '').replace(/\D/g, '').slice(0, 2);

    if (!wholeValue && !decimalValue) return '';

    const wholePart = wholeValue ? parseInt(wholeValue, 10) : 0;
    const decimalPart = decimalValue ? parseInt(decimalValue.padEnd(2, '0'), 10) : 0;
    return String((wholePart * 100) + decimalPart);
  };

  const toDecimalNumber = (whole, decimal) => {
    const scaled = toScaledInt(whole, decimal);
    if (scaled === '') return null;
    return Number(scaled) / 100;
  };

  const calculateBaseWeightByThreadType = (threadType, yarnFactor) => {
    const reedWidth = parseNumeric(formData.reedWidth);
    const normalizedYarnFactor = parseNumeric(yarnFactor);

    if (!reedWidth || !normalizedYarnFactor) return null;

    if (threadType === 1) {
      const weftDensity = toDecimalNumber(densityInputs.weftDensityWhole, densityInputs.weftDensityDecimal);
      if (!weftDensity) return null;

      return (weftDensity * 0.65 / (normalizedYarnFactor / 100)) * reedWidth;
    }

    if (threadType === 2) {
      const reedNo = parseNumeric(formData.reedNo);
      const dgts = parseNumeric(formData.dgts);
      if (!reedNo || !dgts) return null;

      return ((((reedNo * dgts) * 0.65 / (normalizedYarnFactor / 100)) * reedWidth) / 10);
    }

    return null;
  };

  const loadWeaveFactorsForReport = async (weaveGuid) => {
    if (!weaveGuid) {
      setLoadedWeaveFactorRowsByThreadType({ 1: [], 2: [] });
      return;
    }

    try {
      const sessionUserId = localStorage.getItem('sessionUserId');
      const { data } = await getWeaveFactors({
        SessionUserId: sessionUserId,
        WeaveId: weaveGuid
      });

      const list = data?.WeaveFactorList || [];
      setLoadedWeaveFactorRowsByThreadType({
        1: normalizeWeaveFactorRowsFromApi(list, 1),
        2: normalizeWeaveFactorRowsFromApi(list, 2)
      });
    } catch (error) {
      console.error('Error loading weave factor report data:', error);
      setLoadedWeaveFactorRowsByThreadType({ 1: [], 2: [] });
    }
  };

  const handleOpenWeaveFactorModal = async () => {
    const threadType = getCurrentThreadType();
    setShowWeaveFactorModal(true);
    setWeaveFactorModalError('');
    setWeaveFactorModalLoading(true);

    try {
      const sessionUserId = localStorage.getItem('sessionUserId');
      const weaveId = initialData?.WeaveId || null;

      let rowsFromApi = [createEmptyWeaveFactorRow(threadType)];
      if (weaveId) {
        const { data } = await getWeaveFactors({
          SessionUserId: sessionUserId,
          WeaveId: weaveId
        });
        rowsFromApi = normalizeWeaveFactorRowsFromApi(data?.WeaveFactorList || [], threadType);
      }

      setLoadedWeaveFactorRowsByThreadType(prev => ({
        ...prev,
        [threadType]: rowsFromApi
      }));

      const pendingRows = pendingWeaveFactorRowsByThreadType?.[threadType];
      if (Array.isArray(pendingRows)) {
        setWeaveFactorRows(
          pendingRows.length > 0 ? pendingRows : [createEmptyWeaveFactorRow(threadType)]
        );
      } else {
        setWeaveFactorRows(rowsFromApi);
      }
    } catch (error) {
      console.error('Error loading weave factors:', error);
      setWeaveFactorRows([createEmptyWeaveFactorRow(threadType)]);
      setWeaveFactorModalError(t('weaveFactorLoadError') || 'Çarpan verileri yüklenemedi.');
    } finally {
      setWeaveFactorModalLoading(false);
    }
  };

  const handleCloseWeaveFactorModal = () => {
    setShowWeaveFactorModal(false);
    setWeaveFactorModalError('');
  };

  const handleAddWeaveFactorRow = () => {
    const threadType = getCurrentThreadType();
    setWeaveFactorRows(prev => [...prev, createEmptyWeaveFactorRow(threadType)]);
  };

  const handleRemoveWeaveFactorRow = (localId) => {
    setWeaveFactorRows(prev => {
      const next = prev.filter(row => row.localId !== localId);
      return next.length > 0 ? next : [createEmptyWeaveFactorRow(getCurrentThreadType())];
    });
  };

  const hasWeaveFactorFirstSecondConflict = (rows) => {
    const normalizedRows = rows.map((row, idx) => ({
      idx,
      firstColon: String(row.firstColon || '').trim(),
      secondColon: String(row.secondColon || '').trim()
    }));

    return normalizedRows.some((row) => {
      if (!row.firstColon) return false;

      return normalizedRows.some(
        otherRow => otherRow.idx !== row.idx && otherRow.secondColon === row.firstColon
      );
    });
  };

  const handleWeaveFactorInputChange = (localId, field, value) => {
    const cleanValue = value === '' ? '' : value.replace(/[^0-9]/g, '');

    setWeaveFactorRows(prev => {
      const nextRows = prev.map(row => (
        row.localId === localId ? { ...row, [field]: cleanValue } : row
      ));

      if (hasWeaveFactorFirstSecondConflict(nextRows)) {
        setWeaveFactorModalError('Ikinci sutundaki deger ilk sutunda kullanilamaz.');
        return nextRows;
      }

      setWeaveFactorModalError('');
      return nextRows;
    });
  };

  const handleSaveWeaveFactorModal = () => {
    const threadType = getCurrentThreadType();

    // Filter out completely empty placeholder rows (created when last row is deleted)
    const nonEmptyRows = weaveFactorRows.filter(
      row => String(row.firstColon || '').trim() ||
        String(row.secondColon || '').trim() ||
        String(row.factor || '').trim()
    );

    // Validate only non-empty rows: each must have all three fields filled
    const hasInvalidRow = nonEmptyRows.some(
      row => !(String(row.firstColon || '').trim() &&
        String(row.secondColon || '').trim() &&
        String(row.factor || '').trim()),
    );

    if (hasInvalidRow) {
      setWeaveFactorModalError(t('Sütun ve çarpan bilgilerini doldurunuz') || 'Lutfen tum satirlarda ilk sutun, ikinci sutun ve carpan alanlarini doldurun.');
      return;
    }

    if (hasWeaveFactorFirstSecondConflict(nonEmptyRows)) {
      setWeaveFactorModalError('Ikinci sutundaki deger ilk sutunda kullanilamaz.');
      return;
    }

    const cleanedRows = nonEmptyRows.map(row => ({
      ...row,
      threadType,
      firstColon: String(row.firstColon).trim(),
      secondColon: String(row.secondColon).trim(),
      factor: String(row.factor).trim()
    }));

    setPendingWeaveFactorRowsByThreadType(prev => ({
      ...prev,
      [threadType]: cleanedRows
    }));
    setShowWeaveFactorModal(false);
    setWeaveFactorModalError('');
  };

  // Load WeaveColor data when editing
  const loadWeaveColors = async (weaveGuid) => {
    if (!weaveGuid) return;

    setLoadingWeaveColors(true);
    try {
      const sessionUserId = localStorage.getItem('sessionUserId');
      const payload = {
        SessionUserId: sessionUserId,
        PrdWeaveGuid: weaveGuid
      };

      const { data } = await getWeaveColors(payload);
      console.log('WeaveColor data:', data);

      if (data?.WeaveColorList && data.WeaveColorList.length > 0) {
        transformWeaveColorToTable(data.WeaveColorList);
      }
    } catch (error) {
      console.error('Error loading weave colors:', error);
    } finally {
      setLoadingWeaveColors(false);
    }
  };

  // Helper function to format weight values (show 2 decimals)
  const formatWeight = (weight, threadType) => {
    if (!weight || weight === 0) return '';

    let numericWeight;
    if (threadType === 1) { // Weft (atkı)
      numericWeight = weight / 10000; // Convert from API format (3217500 -> 321.75)
    } else if (threadType === 2) { // Warp (çözgü)
      numericWeight = weight / 10000; // Convert from API format (58500000 -> 5850.00)
    } else {
      numericWeight = weight;
    }

    // Ensure exactly 2 decimal places with rounding, then add thousand separators
    const fixed = Number(numericWeight).toFixed(2);
    const parts = fixed.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const decimalPart = parts[1] ?? '00';

    return `${integerPart}.${decimalPart}`;
  };

  // Transform WeaveColor API data to table format
  const transformWeaveColorToTable = (weaveColorList) => {
    // Separate data by ThreadType
    const warpData = weaveColorList.filter(item => item.ThreadType === 2); // ThreadType 2 = çözgü (warp)
    const weftData = weaveColorList.filter(item => item.ThreadType === 1); // ThreadType 1 = atkı (weft)

    // Process warp data
    if (warpData.length > 0) {
      const warpGroups = processTableData(warpData, 2);
      setWarpTableData(warpGroups.tableRows);
      setWarpTableColumns(warpGroups.columnCount);
    }

    // Process weft data
    if (weftData.length > 0) {
      const weftGroups = processTableData(weftData, 1);
      setWeftTableData(weftGroups.tableRows);
      setWeftTableColumns(weftGroups.columnCount);
    }

    // Set initial tab based on which data exists
    if (weftData.length > 0 && warpData.length === 0) {
      setActiveTab('atki');
    } else {
      setActiveTab('cozgu');
    }
  };

  // Helper function to process table data - TAMAMEN YENİDEN YAZILDI
  const processTableData = (dataList, threadType) => {
    if (!dataList || dataList.length === 0) {
      return { tableRows: [], columnCount: 1 };
    }

    const tableRowsByKey = new Map();
    let maxPosition = 0;

    // Önce max pozisyonu bul
    dataList.forEach(item => {
      maxPosition = Math.max(maxPosition, item.Position || 0);
    });

    const columnCount = Math.max(1, maxPosition);

    // Aynı renk+iplik kombinasyonunu tek satırda topla
    dataList.forEach((item, index) => {
      // Weight hesaplama
      let calculatedWeight = 0;
      if (threadType === 1) { // Weft (atkı)
        calculatedWeight = item.WeftWeight || 0;
      } else if (threadType === 2) { // Warp (çözgü)
        calculatedWeight = item.WaftWeight || 0;
      }

      // Renk ve iplik bilgilerini al
      const colorInfo = colorList.find(c => c.ColorId === item.PrdColorGuid);
      const yarnInfo = getYarnInfo(item.PrdYarnGuid);

      const rowKey = `${item.PrdColorGuid || ''}-${item.PrdYarnGuid || ''}`;
      if (!tableRowsByKey.has(rowKey)) {
        tableRowsByKey.set(rowKey, {
          id: Date.now() + index + Math.random(),
          colorId: item.PrdColorGuid || '',
          yarnId: item.PrdYarnGuid || '',
          colorName: colorInfo?.ColorName || '',
          colorCode: colorInfo?.ColorCode || '',
          yarnName: yarnInfo?.Name || '',
          weight: calculatedWeight || '',
          rowSorting: item.RowSorting || index + 1,
          values: new Array(columnCount).fill('')
        });
      }

      const existingRow = tableRowsByKey.get(rowKey);
      const position = item.Position - 1; // API'den 1-based, UI'da 0-based

      if (position >= 0 && position < columnCount) {
        existingRow.values[position] = item.ThreadCount?.toString() || '';
      }

      // Ağırlık boşsa sonraki kayıttan doldur
      if (!existingRow.weight && calculatedWeight) {
        existingRow.weight = calculatedWeight;
      }

      if (item.RowSorting && (!existingRow.rowSorting || item.RowSorting < existingRow.rowSorting)) {
        existingRow.rowSorting = item.RowSorting;
      }
    });

    const tableRows = Array.from(tableRowsByKey.values())
      .sort((a, b) => (a.rowSorting || Number.MAX_SAFE_INTEGER) - (b.rowSorting || Number.MAX_SAFE_INTEGER));

    console.log('Processed table data (GROUPED BY COLOR+YARN):', {
      originalDataCount: dataList.length,
      processedRowCount: tableRows.length,
      columnCount: columnCount,
      tableRows: tableRows
    });

    return { tableRows, columnCount };
  };

  // Helper function to get yarn info
  const getYarnInfo = (yarnId) => {
    const allYarns = getYarns();
    return allYarns.find(yarn => yarn.Guid === yarnId);
  };

  const calculateTableWeightsForThreadType = (tableData, threadType) => {
    if (!Array.isArray(tableData) || tableData.length === 0) return tableData;

    const rowTotals = tableData.map(row => getWeightedRowTotalForThreadType(row, threadType));
    const grandTotal = rowTotals.reduce((sum, total) => sum + total, 0);

    return tableData.map((row, index) => {
      const rowTotal = rowTotals[index];
      const yarnFactor = parseNumeric(getYarnInfo(row.yarnId)?.YarnFactor);
      const baseWeight = calculateBaseWeightByThreadType(threadType, yarnFactor);

      if (!baseWeight || grandTotal <= 0 || rowTotal <= 0) {
        return { ...row, weight: '' };
      }

      const rowRatio = rowTotal / grandTotal;
      const weightedGram = baseWeight * rowRatio;

      return { ...row, weight: scaleWeightToInt(weightedGram) };
    });
  };

  const calculateTotalThreadsFromFields = () => {
    const reedNo = parseNumeric(formData.reedNo);
    const dgts = parseNumeric(formData.dgts);
    const reedWidth = parseNumeric(formData.reedWidth);

    if (!reedNo || !dgts || !reedWidth) return '';

    const total = Math.trunc((reedNo * dgts * reedWidth) / 10);
    return total > 0 ? String(total) : '';
  };

  useEffect(() => {
    console.info(`[WeaveInputs] ${WEAVE_INPUTS_BUILD_MARK}`);
  }, []);

  useEffect(() => {
    if (initialData) {
      const warpDensity = parseScaledDecimalParts(initialData.WarpDensity);
      const weftDensity = parseScaledDecimalParts(initialData.WeftDensity);
      setDensityInputs({
        warpDensityWhole: warpDensity.whole,
        warpDensityDecimal: warpDensity.decimal,
        weftDensityWhole: weftDensity.whole,
        weftDensityDecimal: weftDensity.decimal
      });

      setFormData({
        weaveCode: initialData.WeaveCode || '',
        description: initialData.Description || '',
        warpDensity: warpDensity.whole || warpDensity.decimal ? `${warpDensity.whole || '0'}.${warpDensity.decimal || '00'}` : '',
        weftDensity: weftDensity.whole || weftDensity.decimal ? `${weftDensity.whole || '0'}.${weftDensity.decimal || '00'}` : '',
        reedWidth: initialData.ReedWidth || '',
        reedNo: initialData.ReedNo || '',
        dgts: initialData.Dgts || '',
        totalThreads: initialData.TotalThreads || '',
        prdCompositionGuid: initialData.PrdCompositionGuid || '',
        prdWeaveTypeGuid: initialData.PrdWeaveTypeGuid || '',
        fabricWidth: initialData.FabricWidth || '',
        fabricWeight: initialData.FabricWeight
          ? Math.trunc(Number(initialData.FabricWeight) / 100).toString()
          : '',
        photo: initialData.Photo || '',
        photoWeave: initialData.PhotoWeave || ''
      });
      setTotalThreadsEditedByUser(false);

      if (initialData.Photo) {
        setImagePreview(initialData.Photo);
      } else {
        setImagePreview(null);
      }

      if (initialData.PhotoWeave) {
        setImagePreviewWeave(initialData.PhotoWeave);
      } else {
        setImagePreviewWeave(null);
      }

      latestImagesRef.current = {
        photo: initialData.Photo || '',
        photoWeave: initialData.PhotoWeave || ''
      };
    }
  }, [initialData]);

  useEffect(() => {
    const warpDensity = densityInputs.warpDensityWhole || densityInputs.warpDensityDecimal
      ? `${densityInputs.warpDensityWhole || '0'}.${densityInputs.warpDensityDecimal || '00'}`
      : '';
    const weftDensity = densityInputs.weftDensityWhole || densityInputs.weftDensityDecimal
      ? `${densityInputs.weftDensityWhole || '0'}.${densityInputs.weftDensityDecimal || '00'}`
      : '';

    setFormData(prev => ({
      ...prev,
      warpDensity,
      weftDensity
    }));
  }, [
    densityInputs.warpDensityWhole,
    densityInputs.warpDensityDecimal,
    densityInputs.weftDensityWhole,
    densityInputs.weftDensityDecimal
  ]);

  useEffect(() => {
    if (isEdit && initialData?.WeaveId && colorList.length > 0) {
      loadWeaveColors(initialData.WeaveId);
    }
  }, [isEdit, initialData?.WeaveId, colorList.length]);

  useEffect(() => {
    if (isEdit && initialData?.WeaveId) {
      loadWeaveFactorsForReport(initialData.WeaveId);
    }
  }, [isEdit, initialData?.WeaveId]);

  useEffect(() => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    if (sessionUserId) {
      dispatch(getColorRequestAction({ SessionUserId: sessionUserId }));
    }
  }, [dispatch]);

  useEffect(() => {
    refreshWeaveDropdownData();
  }, []);

  useEffect(() => {
    if (cropSkipped === false) {
      setManualCropArea(null);
    }
  }, [cropSkipped]);

  useEffect(() => {
    console.log('📥 Submit Response:', submitResponse);

    if (submitResponse?.Result?.ErrorCode === 0) {
      if (!isEdit) {
        setFormData({
          weaveCode: '',
          description: '',
          warpDensity: '',
          weftDensity: '',
          reedWidth: '',
          reedNo: '',
          dgts: '',
          totalThreads: '',
          prdCompositionGuid: '',
          prdWeaveTypeGuid: '',
          fabricWidth: '',
          fabricWeight: '',
          photo: '',
          photoWeave: ''
        });
        setTotalThreadsEditedByUser(false);
        setDensityInputs({
          warpDensityWhole: '',
          warpDensityDecimal: '',
          weftDensityWhole: '',
          weftDensityDecimal: ''
        });
        setImagePreview(null);
        setImagePreviewWeave(null);
        latestImagesRef.current = { photo: '', photoWeave: '' };
        setCropImageSrc(null);
        setCropModalVisible(false);
        setWarpTableData([]);
        setWeftTableData([]);
        setWarpTableColumns(1);
        setWeftTableColumns(1);
        setShowSaveButton(false);
        setActiveTab('cozgu');
        setBulkAddRows({ warp: 1, weft: 1 });
        setBulkAddColumns({ warp: 1, weft: 1 });
        setLoadedWeaveFactorRowsByThreadType({ 1: [], 2: [] });
        setPendingWeaveFactorRowsByThreadType({ 1: null, 2: null });
      }
    }
  }, [submitResponse, isEdit]);

  useEffect(() => {
    const requiredFieldsFilled =
      formData.weaveCode.trim()

    setShowSaveButton(requiredFieldsFilled);

    if (requiredFieldsFilled && warpTableData.length === 0 && weftTableData.length === 0 && !isEdit) {
      initializeTables();
    }
  }, [formData, warpTableData.length, weftTableData.length, isEdit]);

  // Update columns for both tables
  useEffect(() => {
    if (warpTableData.length > 0) {
      setWarpTableData(prev => prev.map(row => {
        if (row.values.length !== warpTableColumns) {
          const newValues = [...row.values];
          if (newValues.length < warpTableColumns) {
            while (newValues.length < warpTableColumns) {
              newValues.push('');
            }
          } else if (newValues.length > warpTableColumns) {
            newValues.splice(warpTableColumns);
          }
          return { ...row, values: newValues };
        }
        return row;
      }));
    }
  }, [warpTableColumns]);

  useEffect(() => {
    if (weftTableData.length > 0) {
      setWeftTableData(prev => prev.map(row => {
        if (row.values.length !== weftTableColumns) {
          const newValues = [...row.values];
          if (newValues.length < weftTableColumns) {
            while (newValues.length < weftTableColumns) {
              newValues.push('');
            }
          } else if (newValues.length > weftTableColumns) {
            newValues.splice(weftTableColumns);
          }
          return { ...row, values: newValues };
        }
        return row;
      }));
    }
  }, [weftTableColumns]);

  useEffect(() => {
    setWarpTableData(prev => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;

      const next = calculateTableWeightsForThreadType(prev, 2);
      const hasWeightChange = next.some((row, idx) => row.weight !== prev[idx]?.weight);

      return hasWeightChange ? next : prev;
    });
  }, [
    warpTableData,
    formData.reedNo,
    formData.dgts,
    formData.reedWidth,
    dropdownData.Yarns,
    loadedWeaveFactorRowsByThreadType,
    pendingWeaveFactorRowsByThreadType,
  ]);

  useEffect(() => {
    setWeftTableData(prev => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;

      const next = calculateTableWeightsForThreadType(prev, 1);
      const hasWeightChange = next.some((row, idx) => row.weight !== prev[idx]?.weight);

      return hasWeightChange ? next : prev;
    });
  }, [
    weftTableData,
    densityInputs.weftDensityWhole,
    densityInputs.weftDensityDecimal,
    formData.reedWidth,
    dropdownData.Yarns,
    loadedWeaveFactorRowsByThreadType,
    pendingWeaveFactorRowsByThreadType,
  ]);

  useEffect(() => {
    if (isEdit || totalThreadsEditedByUser) return;

    const calculatedTotalThreads = calculateTotalThreadsFromFields();
    setFormData(prev => {
      if (prev.totalThreads === calculatedTotalThreads) return prev;
      return { ...prev, totalThreads: calculatedTotalThreads };
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isEdit,
    totalThreadsEditedByUser,
    formData.reedNo,
    formData.dgts,
    formData.reedWidth,
  ]);

  const initializeTables = () => {
    // Initialize both tables with one row each
    const initialWarpRow = {
      id: Date.now() + 1,
      colorId: '',
      yarnId: '',
      colorName: '',
      colorCode: '',
      yarnName: '',
      weight: '',
      values: new Array(warpTableColumns).fill('')
    };

    const initialWeftRow = {
      id: Date.now() + 2,
      colorId: '',
      yarnId: '',
      colorName: '',
      colorCode: '',
      yarnName: '',
      weight: '',
      values: new Array(weftTableColumns).fill('')
    };

    setWarpTableData([initialWarpRow]);
    setWeftTableData([initialWeftRow]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'totalThreads') {
      setTotalThreadsEditedByUser(true);
    }
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleImageSelect = (e, targetField = 'photo') => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      window.alert('Lutfen bir gorsel dosyasi secin');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        setImageDimensions({ width: img.width, height: img.height });
      };
      img.src = reader.result;
      
      cropTargetFieldRef.current = targetField;
      setCropTargetField(targetField);
      if (targetField === 'photoWeave') {
        setWeaveCropPresetKey('square400');
      }
      setCropImageSrc(reader.result);
      setCroppedAreaPixels(null);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setCropSkipped(false);
      setCropModalVisible(true);
    };
    reader.readAsDataURL(file);
  };

  const onCropComplete = (_croppedArea, croppedAreaPx) => {
    setCroppedAreaPixels(croppedAreaPx);
  };

  const getCroppedImg = (imageSrc, pixelCrop, targetSize) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        // Eğer kırpma yapılmadıysa (pixelCrop null), orijinal resmi olduğu gibi döndür
        if (!pixelCrop || (pixelCrop.width === 0 || pixelCrop.height === 0)) {
          resolve(imageSrc);
          return;
        }

        const canvas = document.createElement('canvas');
        const targetWidth = targetSize?.width || 400;
        const targetHeight = targetSize?.height || 400;
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');

        const naturalWidth = image.naturalWidth || image.width;
        const naturalHeight = image.naturalHeight || image.height;
        const safeCrop = (pixelCrop && pixelCrop.width > 0 && pixelCrop.height > 0)
          ? pixelCrop
          : { x: 0, y: 0, width: naturalWidth, height: naturalHeight };

        ctx.drawImage(
          image,
          safeCrop.x,
          safeCrop.y,
          safeCrop.width,
          safeCrop.height,
          0,
          0,
          targetWidth,
          targetHeight,
        );

        resolve(canvas.toDataURL('image/jpeg', 0.92));
      };
      image.src = imageSrc;
    });
  };

  const handleCropConfirm = async () => {
    if (!cropImageSrc) return;
    const targetField = cropTargetFieldRef.current || cropTargetField;

    let croppedImage = cropImageSrc;

    if (cropSkipped) {
      // Kırpmayı atla - orijinal resmi olduğu gibi kaydet
      croppedImage = cropImageSrc;
      
      latestImagesRef.current = {
        ...latestImagesRef.current,
        [targetField]: croppedImage
      };
      setFormData(prev => ({ ...prev, [targetField]: croppedImage }));

      if (targetField === 'photoWeave') {
        setImagePreviewWeave(croppedImage);
      } else {
        setImagePreview(croppedImage);
      }

      setCropModalVisible(false);
      setCropImageSrc(null);
      setCroppedAreaPixels(null);
      setCropSkipped(false);
      setManualCropArea(null);
      setImageDimensions({ width: 0, height: 0 });

      const activeFileInputRef = targetField === 'photoWeave' ? weaveFileInputRef : armureFileInputRef;
      if (activeFileInputRef.current) {
        activeFileInputRef.current.value = '';
      }
    } else {
      // Normal kırpma
      const targetSize = targetField === 'photoWeave'
        ? cropPresets[weaveCropPresetKey] || cropPresets.square400
        : cropPresets.square400;
      croppedImage = await getCroppedImg(cropImageSrc, croppedAreaPixels, targetSize);
      latestImagesRef.current = {
        ...latestImagesRef.current,
        [targetField]: croppedImage
      };
      setFormData(prev => ({ ...prev, [targetField]: croppedImage }));

      if (targetField === 'photoWeave') {
        setImagePreviewWeave(croppedImage);
      } else {
        setImagePreview(croppedImage);
      }

      setCropModalVisible(false);
      setCropImageSrc(null);
      setCroppedAreaPixels(null);
      setCropSkipped(false);
      setManualCropArea(null);
      setImageDimensions({ width: 0, height: 0 });

      const activeFileInputRef = targetField === 'photoWeave' ? weaveFileInputRef : armureFileInputRef;
      if (activeFileInputRef.current) {
        activeFileInputRef.current.value = '';
      }
    }
  };

  const handleCropSkip = () => {
    if (!cropImageSrc) return;
    
    // Kırpmayı atla - sadece Cropper'ı gizle, tam resmi olduğu gibi göster
    setCropSkipped(true);
  };

  const handleCropCancel = () => {
    setCropModalVisible(false);
    setCropImageSrc(null);
    setCroppedAreaPixels(null);
    setCropSkipped(false);
    setManualCropArea(null);
    setIsDraggingHandle(null);
    setImageDimensions({ width: 0, height: 0 });
    const targetField = cropTargetFieldRef.current || cropTargetField;
    const activeFileInputRef = targetField === 'photoWeave' ? weaveFileInputRef : armureFileInputRef;
    if (activeFileInputRef.current) {
      activeFileInputRef.current.value = '';
    }
  };

  const drawManualCropArea = (canvas, context, area, imgWidth, imgHeight) => {
    if (!canvas || !area) return;

    context.clearRect(0, 0, canvas.width, canvas.height);

    // Karanlı bölgeyi çiz
    context.fillStyle = 'rgba(0, 0, 0, 0.5)';
    context.fillRect(0, 0, canvas.width, canvas.height);

    // Kırpma alanını temizle (transparent)
    context.clearRect(area.x, area.y, area.width, area.height);

    // Kırpma alanının sınırını çiz
    context.strokeStyle = '#00ff00';
    context.lineWidth = 2;
    context.strokeRect(area.x, area.y, area.width, area.height);

    // Handle'lar çiz
    const handleSize = 10;
    context.fillStyle = '#00ff00';
    
    // Top-left
    context.fillRect(area.x - handleSize / 2, area.y - handleSize / 2, handleSize, handleSize);
    // Top-right
    context.fillRect(area.x + area.width - handleSize / 2, area.y - handleSize / 2, handleSize, handleSize);
    // Bottom-left
    context.fillRect(area.x - handleSize / 2, area.y + area.height - handleSize / 2, handleSize, handleSize);
    // Bottom-right
    context.fillRect(area.x + area.width - handleSize / 2, area.y + area.height - handleSize / 2, handleSize, handleSize);
  };

  useEffect(() => {
    if (!cropSkipped || !manualCropCanvasRef.current) return;

    const canvas = manualCropCanvasRef.current;

    const getHandleAtPos = (x, y, area) => {
      const handleSize = 10;
      if (!area) return null;

      // Top-left
      if (x >= area.x - handleSize && x <= area.x + handleSize &&
          y >= area.y - handleSize && y <= area.y + handleSize) {
        return 'tl';
      }
      // Top-right
      if (x >= area.x + area.width - handleSize && x <= area.x + area.width + handleSize &&
          y >= area.y - handleSize && y <= area.y + handleSize) {
        return 'tr';
      }
      // Bottom-left
      if (x >= area.x - handleSize && x <= area.x + handleSize &&
          y >= area.y + area.height - handleSize && y <= area.y + area.height + handleSize) {
        return 'bl';
      }
      // Bottom-right
      if (x >= area.x + area.width - handleSize && x <= area.x + area.width + handleSize &&
          y >= area.y + area.height - handleSize && y <= area.y + area.height + handleSize) {
        return 'br';
      }
      return null;
    };

    const handleMouseDown = (e) => {
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const handle = getHandleAtPos(x, y, manualCropArea);
      if (handle) {
        setIsDraggingHandle(handle);
      }
    };

    const handleMouseMove = (e) => {
      if (!isDraggingHandle || !manualCropArea) return;

      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const img = new Image();
      img.onload = () => {
        const maxWidth = img.width;
        const maxHeight = img.height;

        const minWidth = 50;
        const minHeight = 50;

        let newArea = { ...manualCropArea };

        if (isDraggingHandle === 'tl') {
          newArea.x = Math.max(0, Math.min(x, newArea.x + newArea.width - minWidth));
          newArea.y = Math.max(0, Math.min(y, newArea.y + newArea.height - minHeight));
          newArea.width = manualCropArea.x + manualCropArea.width - newArea.x;
          newArea.height = manualCropArea.y + manualCropArea.height - newArea.y;
        } else if (isDraggingHandle === 'tr') {
          newArea.y = Math.max(0, Math.min(y, newArea.y + newArea.height - minHeight));
          newArea.width = Math.max(minWidth, x - newArea.x);
          newArea.height = manualCropArea.y + manualCropArea.height - newArea.y;
          newArea.width = Math.min(newArea.width, maxWidth - newArea.x);
        } else if (isDraggingHandle === 'bl') {
          newArea.x = Math.max(0, Math.min(x, newArea.x + newArea.width - minWidth));
          newArea.height = Math.max(minHeight, y - newArea.y);
          newArea.width = manualCropArea.x + manualCropArea.width - newArea.x;
          newArea.height = Math.min(newArea.height, maxHeight - newArea.y);
        } else if (isDraggingHandle === 'br') {
          newArea.width = Math.max(minWidth, x - newArea.x);
          newArea.height = Math.max(minHeight, y - newArea.y);
          newArea.width = Math.min(newArea.width, maxWidth - newArea.x);
          newArea.height = Math.min(newArea.height, maxHeight - newArea.y);
        }

        setManualCropArea(newArea);
      };
      img.src = cropImageSrc;
    };

    const handleMouseUp = () => {
      setIsDraggingHandle(null);
    };

    canvas.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      canvas.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [cropSkipped, manualCropArea, isDraggingHandle, cropImageSrc]);

  const handleImageClick = (targetField = 'photo') => {
    if (targetField === 'photoWeave') {
      weaveFileInputRef.current?.click();
      return;
    }

    armureFileInputRef.current?.click();
  };

  const handleOpenImageModal = (src, title) => {
    if (!src) return;
    setImageModalSrc(src);
    setImageModalTitle(title);
    setImageModal(true);
  };

  const handleRemoveImage = (targetField = 'photo') => {
    // null means "delete image" for update flow in backend.
    latestImagesRef.current = {
      ...latestImagesRef.current,
      [targetField]: null
    };
    setFormData(prev => ({ ...prev, [targetField]: null }));

    if (targetField === 'photoWeave') {
      setImagePreviewWeave(null);
      if (weaveFileInputRef.current) {
        weaveFileInputRef.current.value = '';
      }
      return;
    }

    setImagePreview(null);
    if (armureFileInputRef.current) {
      armureFileInputRef.current.value = '';
    }
  };

  const handleDensityInputChange = (field, part, value) => {
    if (part === 'whole' && !/^\d*$/.test(value)) return;
    if (part === 'decimal' && !/^\d{0,2}$/.test(value)) return;

    const stateField = `${field}Density${part.charAt(0).toUpperCase() + part.slice(1)}`;
    setDensityInputs(prev => ({
      ...prev,
      [stateField]: value
    }));
  };

  const handleDensityKeyDown = (e, field, part) => {
    if (part === 'whole') {
      const isDotOrCommaKey = e.key === '.' || e.key === ',' || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 188;
      if (isDotOrCommaKey) {
        e.preventDefault();
        const decimalInput = document.getElementById(`${field}DensityDecimal`);
        if (decimalInput) {
          decimalInput.focus();
          const valueLength = decimalInput.value ? decimalInput.value.length : 0;
          try {
            decimalInput.setSelectionRange(valueLength, valueLength);
          } catch (err) {
            // Ignore unsupported input selection APIs.
          }
        }
        return;
      }
    }

    if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode === 67 && e.ctrlKey === true) ||
      (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }

    if (part === 'decimal') {
      const currentValue = e.target.value;
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;

      if (currentValue.length >= 2 && selectionStart === selectionEnd) {
        e.preventDefault();
        return;
      }
    }

    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };

  const handleDensityBlur = (field, part) => {
    if (part !== 'decimal') return;

    const wholeField = `${field}DensityWhole`;
    const decimalField = `${field}DensityDecimal`;
    const currentValue = densityInputs[decimalField];

    if (currentValue !== '' && currentValue.length === 1) {
      setDensityInputs(prev => ({
        ...prev,
        [decimalField]: currentValue.padEnd(2, '0')
      }));
    } else if (currentValue === '' && densityInputs[wholeField]) {
      setDensityInputs(prev => ({
        ...prev,
        [decimalField]: '00'
      }));
    }
  };

  const resetAddColorModal = () => {
    setAddColorForm({ colorName: '', colorCode: '', colorDescription: '' });
    setAddColorErrors({});
  };

  const resetAddYarnModal = () => {
    setAddYarnForm({ yarnCode: '', yarnName: '', yarnType: '', yarnDescription: '' });
    setAddYarnErrors({});
  };

  const resetAddCompositionModal = () => {
    setAddCompositionForm({ threadName: '', threadDescription: '' });
    setAddCompositionErrors({});
  };

  const resetAddWeaveTypeModal = () => {
    setAddWeaveTypeForm({ weaveTypeName: '', weaveTypeDescription: '' });
    setAddWeaveTypeErrors({});
  };

  const handleOpenAddColorModal = () => {
    resetAddColorModal();
    setShowAddColorModal(true);
  };

  const handleOpenAddYarnModal = () => {
    resetAddYarnModal();
    setShowAddYarnModal(true);
  };

  const handleOpenAddCompositionModal = () => {
    resetAddCompositionModal();
    setShowAddCompositionModal(true);
  };

  const handleOpenAddWeaveTypeModal = () => {
    resetAddWeaveTypeModal();
    setShowAddWeaveTypeModal(true);
  };

  const handleAddColorSubmit = async () => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const newErrors = {};

    if (!addColorForm.colorName.trim()) {
      newErrors.colorName = t('colorNameRequired') || 'Renk adi zorunlu.';
    }

    if (!sessionUserId) {
      newErrors.general = t('userSessionNotFound') || 'Kullanici oturumu bulunamadi.';
    }

    setAddColorErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setAddColorLoading(true);
    try {
      const payload = {
        SessionUserId: sessionUserId,
        ColorName: addColorForm.colorName.trim(),
        ColorCode: addColorForm.colorCode.trim(),
        ColorDescription: addColorForm.colorDescription.trim(),
      };

      const response = await createColor(payload);
      const data = response?.data || response;

      if (data?.Result?.ErrorCode === 0) {
        setQuickCreateFeedback({
          type: 'success',
          message: data?.Result?.ErrorDescription || (t('colorCreated') || 'Renk olusturuldu.')
        });
        setShowAddColorModal(false);
        resetAddColorModal();
        dispatch(getColorRequestAction({ SessionUserId: sessionUserId }));
        await refreshWeaveDropdownData();
      } else {
        setAddColorErrors({
          general: data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
        });
      }
    } catch (error) {
      setAddColorErrors({
        general: error?.response?.data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
      });
    } finally {
      setAddColorLoading(false);
    }
  };

  const handleAddCompositionSubmit = async () => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const newErrors = {};

    if (!addCompositionForm.threadName.trim()) {
      newErrors.threadName = t('threadNameRequired') || 'Kompozisyon adi zorunlu.';
    }
    if (!sessionUserId) {
      newErrors.general = t('userSessionNotFound') || 'Kullanici oturumu bulunamadi.';
    }

    setAddCompositionErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setAddCompositionLoading(true);
    try {
      const response = await createComposition({
        SessionUserId: sessionUserId,
        ThreadName: addCompositionForm.threadName.trim(),
        ThreadDescription: addCompositionForm.threadDescription.trim(),
      });
      const data = response?.data || response;

      if (data?.Result?.ErrorCode === 0) {
        const createdName = addCompositionForm.threadName.trim();
        const dropdownResponse = await getWeaveDropdown({ SessionUserId: sessionUserId });
        const nextDropdownData = dropdownResponse?.data || {};
        const createdComposition = (nextDropdownData.Compositions || []).find(
          item => item.ThreadName === createdName
        );

        setDropdownData(nextDropdownData);
        if (createdComposition?.PrdCompositionGuid) {
          setFormData(prev => ({
            ...prev,
            prdCompositionGuid: createdComposition.PrdCompositionGuid
          }));
        }
        setQuickCreateFeedback({
          type: 'success',
          message: data?.Result?.ErrorDescription || (t('compositionCreated') || 'Kompozisyon olusturuldu.')
        });
        setShowAddCompositionModal(false);
        resetAddCompositionModal();
      } else {
        setAddCompositionErrors({
          general: data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
        });
      }
    } catch (error) {
      setAddCompositionErrors({
        general: error?.response?.data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
      });
    } finally {
      setAddCompositionLoading(false);
    }
  };

  const handleAddWeaveTypeSubmit = async () => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const newErrors = {};

    if (!addWeaveTypeForm.weaveTypeName.trim()) {
      newErrors.weaveTypeName = t('weaveTypeNameRequired') || 'Orgu tipi adi zorunlu.';
    }
    if (!sessionUserId) {
      newErrors.general = t('userSessionNotFound') || 'Kullanici oturumu bulunamadi.';
    }

    setAddWeaveTypeErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setAddWeaveTypeLoading(true);
    try {
      const response = await createWeaveType({
        SessionUserId: sessionUserId,
        WeaveTypeName: addWeaveTypeForm.weaveTypeName.trim(),
        WeaveTypeDescription: addWeaveTypeForm.weaveTypeDescription.trim(),
      });
      const data = response?.data || response;

      if (data?.Result?.ErrorCode === 0) {
        const createdName = addWeaveTypeForm.weaveTypeName.trim();
        const dropdownResponse = await getWeaveDropdown({ SessionUserId: sessionUserId });
        const nextDropdownData = dropdownResponse?.data || {};
        const createdWeaveType = (nextDropdownData.WeaveTypes || []).find(
          item => item.WeaveTypeName === createdName
        );

        setDropdownData(nextDropdownData);
        if (createdWeaveType?.PrdWeaveTypeGuid) {
          setFormData(prev => ({ ...prev, prdWeaveTypeGuid: createdWeaveType.PrdWeaveTypeGuid }));
        }
        setQuickCreateFeedback({
          type: 'success',
          message: data?.Result?.ErrorDescription || (t('weaveTypeCreated') || 'Orgu tipi olusturuldu.')
        });
        setShowAddWeaveTypeModal(false);
        resetAddWeaveTypeModal();
      } else {
        setAddWeaveTypeErrors({
          general: data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
        });
      }
    } catch (error) {
      setAddWeaveTypeErrors({
        general: error?.response?.data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
      });
    } finally {
      setAddWeaveTypeLoading(false);
    }
  };

  const handleAddYarnSubmit = async () => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const newErrors = {};

    if (!addYarnForm.yarnCode.trim()) {
      newErrors.yarnCode = t('Yarn Code Required') || 'Iplik kodu zorunlu.';
    }

    if (!addYarnForm.yarnType) {
      newErrors.yarnType = t('Yarn Type Required') || 'Iplik tipi zorunlu.';
    }

    if (!sessionUserId) {
      newErrors.general = t('userSessionNotFound') || 'Kullanici oturumu bulunamadi.';
    }

    setAddYarnErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setAddYarnLoading(true);
    try {
      const payload = {
        SessionUserId: sessionUserId,
        YarnCode: addYarnForm.yarnCode.trim(),
        YarnName: addYarnForm.yarnName.trim(),
        YarnType: addYarnForm.yarnType,
        YarnDescription: addYarnForm.yarnDescription.trim(),
      };

      const response = await createYarn(payload);
      const data = response?.data || response;

      if (data?.Result?.ErrorCode === 0) {
        setQuickCreateFeedback({
          type: 'success',
          message: data?.Result?.ErrorDescription || (t('yarnCreated') || 'Iplik olusturuldu.')
        });
        setShowAddYarnModal(false);
        resetAddYarnModal();
        await refreshWeaveDropdownData();
      } else {
        setAddYarnErrors({
          general: data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
        });
      }
    } catch (error) {
      setAddYarnErrors({
        general: error?.response?.data?.Result?.ErrorDescription || (t('anErrorOccurred') || 'Kayit sirasinda hata olustu.')
      });
    } finally {
      setAddYarnLoading(false);
    }
  };

  const handleColorSelection = (rowIndex, colorId, isWarp) => {
    const selectedColor = colorList.find(c => c.ColorId === colorId);
    if (selectedColor) {
      if (isWarp) {
        setWarpTableData(prev => prev.map((row, index) =>
          index === rowIndex
            ? { ...row, colorId, colorName: selectedColor.ColorName, colorCode: selectedColor.ColorCode }
            : row
        ));
      } else {
        setWeftTableData(prev => prev.map((row, index) =>
          index === rowIndex
            ? { ...row, colorId, colorName: selectedColor.ColorName, colorCode: selectedColor.ColorCode }
            : row
        ));
      }
    }
  };

  const handleYarnSelection = (rowIndex, yarnId, isWarp) => {
    const yarnInfo = getYarnInfo(yarnId);
    if (yarnInfo) {
      if (isWarp) {
        setWarpTableData(prev => prev.map((row, index) =>
          index === rowIndex
            ? { ...row, yarnId, yarnName: yarnInfo.Name }
            : row
        ));
      } else {
        setWeftTableData(prev => prev.map((row, index) =>
          index === rowIndex
            ? { ...row, yarnId, yarnName: yarnInfo.Name }
            : row
        ));
      }
    }
  };

  const normalizeThreadCountValue = (rawValue) => {
    if (rawValue === null || rawValue === undefined) return '';

    const digitsOnly = String(rawValue).replace(/[^0-9]/g, '');
    if (!digitsOnly) return '';

    const numericValue = parseInt(digitsOnly, 10);
    if (!Number.isFinite(numericValue) || numericValue <= 0) return '';

    return String(numericValue);
  };

  const hasValueInOtherRowForColumn = (rows, currentRowIndex, colIndex) => {
    return rows.some((row, rowIndex) => {
      if (rowIndex === currentRowIndex) return false;
      return (parseInt(row?.values?.[colIndex], 10) || 0) > 0;
    });
  };

  const removeSourceIndex = (rows) => rows.map((row) => {
    const nextRow = { ...row };
    delete nextRow.sourceIndex;
    return nextRow;
  });

  const handleCellValueChange = (rowIndex, colIndex, value, isWarp) => {//değer girince çalışıyor
    const normalizedValue = normalizeThreadCountValue(value);

    if (isWarp) {
      setWarpTableData(prev => {
        if (normalizedValue !== '' && hasValueInOtherRowForColumn(prev, rowIndex, colIndex)) {//başka satır dolu mu kontrolü
          return prev;
        }

        const nextRows = prev.map((row, index) => (
          index === rowIndex
            ? { ...row, values: row.values.map((v, i) => i === colIndex ? normalizedValue : v) }
            : row
        ));

        return removeSourceIndex(nextRows);
      });
    } else {
      setWeftTableData(prev => {
        if (normalizedValue !== '' && hasValueInOtherRowForColumn(prev, rowIndex, colIndex)) {
          return prev;
        }

        const nextRows = prev.map((row, index) => (
          index === rowIndex
            ? { ...row, values: row.values.map((v, i) => i === colIndex ? normalizedValue : v) }
            : row
        ));

        return removeSourceIndex(nextRows);
      });
    }
  };

  const getCellInputSelector = (tableType, rowIndex, colIndex) => (
    `input.table-input[data-table-type="${tableType}"][data-row-index="${rowIndex}"][data-col-index="${colIndex}"]`
  );

  const focusNextAvailableCell = (tableType, startRow, startCol, rowStep, colStep, rowCount, colCount) => {
    let nextRow = startRow + rowStep;
    let nextCol = startCol + colStep;

    while (nextRow >= 0 && nextRow < rowCount && nextCol >= 0 && nextCol < colCount) {
      const input = document.querySelector(getCellInputSelector(tableType, nextRow, nextCol));

      if (input && !input.disabled) {
        input.focus();
        if (typeof input.select === 'function') input.select();
        return;
      }

      nextRow += rowStep;
      nextCol += colStep;
    }
  };

  const handleCellKeyDown = (event, rowIndex, colIndex, isWarp, rowCount, colCount) => {
    const tableType = isWarp ? 'warp' : 'weft';

    switch (event.key) {
      case 'ArrowRight':
        event.preventDefault();
        focusNextAvailableCell(tableType, rowIndex, colIndex, 0, 1, rowCount, colCount);
        break;
      case 'ArrowLeft':
        event.preventDefault();
        focusNextAvailableCell(tableType, rowIndex, colIndex, 0, -1, rowCount, colCount);
        break;
      case 'ArrowDown':
        event.preventDefault();
        focusNextAvailableCell(tableType, rowIndex, colIndex, 1, 0, rowCount, colCount);
        break;
      case 'ArrowUp':
        event.preventDefault();
        focusNextAvailableCell(tableType, rowIndex, colIndex, -1, 0, rowCount, colCount);
        break;
      default:
        break;
    }
  };

  // Bulk add rows function
  const addRows = (isWarp, count = 1) => {
    const addCount = Math.max(1, Math.min(1000, parseInt(count, 10) || 1));
    const tableColumns = isWarp ? warpTableColumns : weftTableColumns;
    const newRows = [];

    for (let i = 0; i < addCount; i++) {
      newRows.push({
        id: Date.now() + Math.random() + i,
        colorId: '',
        yarnId: '',
        colorName: '',
        colorCode: '',
        yarnName: '',
        weight: '',
        values: new Array(tableColumns).fill('')
      });
    }

    if (isWarp) {
      setWarpTableData(prev => [...prev, ...newRows]);
    } else {
      setWeftTableData(prev => [...prev, ...newRows]);
    }
  };

  // Single row add function (kept for backward compatibility)
  const addRow = (isWarp) => {
    addRows(isWarp, 1);
  };

  const removeRow = (rowIndex, isWarp) => {
    if (isWarp) {
      if (warpTableData.length > 1) {
        setWarpTableData(prev => prev.filter((_, index) => index !== rowIndex));
      }
    } else {
      if (weftTableData.length > 1) {
        setWeftTableData(prev => prev.filter((_, index) => index !== rowIndex));
      }
    }
  };

  // Bulk add columns function
  const addColumns = (isWarp, count = 1) => {
    const addCount = Math.max(1, Math.min(1000, parseInt(count, 10) || 1));
    if (isWarp) {
      setWarpTableColumns(prev => prev + addCount);
    } else {
      setWeftTableColumns(prev => prev + addCount);
    }
  };

  // Single column add function (kept for backward compatibility)
  const addColumn = (isWarp) => {
    addColumns(isWarp, 1);
  };

  const removeColumn = (isWarp) => {
    if (isWarp) {
      if (warpTableColumns > 1) {
        setWarpTableColumns(prev => prev - 1);
      }
    } else {
      if (weftTableColumns > 1) {
        setWeftTableColumns(prev => prev - 1);
      }
    }
  };

  // Bulk remove rows function
  const removeRows = (isWarp, count = 1) => {
    const removeCount = Math.max(1, parseInt(count) || 1);
    if (isWarp) {
      setWarpTableData(prev => {
        const newLength = Math.max(1, prev.length - removeCount);
        return prev.slice(0, newLength);
      });
    } else {
      setWeftTableData(prev => {
        const newLength = Math.max(1, prev.length - removeCount);
        return prev.slice(0, newLength);
      });
    }
  };

  // Bulk remove columns function
  const removeColumns = (isWarp, count = 1) => {
    const removeCount = Math.max(1, parseInt(count) || 1);
    if (isWarp) {
      setWarpTableColumns(prev => Math.max(1, prev - removeCount));
    } else {
      setWeftTableColumns(prev => Math.max(1, prev - removeCount));
    }
  };



  // Handle bulk input changes
  const handleBulkRowsChange = (value, isWarp) => {
    if (value === '') {
      setBulkAddRows(prev => ({
        ...prev,
        [isWarp ? 'warp' : 'weft']: ''
      }));
      return;
    }
    const intVal = parseInt(value, 10);
    const finalVal = Number.isNaN(intVal) ? '' : Math.max(1, Math.min(1000, intVal));
    setBulkAddRows(prev => ({
      ...prev,
      [isWarp ? 'warp' : 'weft']: finalVal
    }));
  };

  const handleBulkColumnsChange = (value, isWarp) => {
    if (value === '') {
      setBulkAddColumns(prev => ({
        ...prev,
        [isWarp ? 'warp' : 'weft']: ''
      }));
      return;
    }
    const intVal = parseInt(value, 10);
    const finalVal = Number.isNaN(intVal) ? '' : Math.max(1, Math.min(1000, intVal));
    setBulkAddColumns(prev => ({
      ...prev,
      [isWarp ? 'warp' : 'weft']: finalVal
    }));
  };

  const calculateRowTotal = (values) => {
    return values.reduce((sum, val) => sum + (parseInt(val) || 0), 0);
  };

  const calculateRowPercentage = (rowTotal, grandTotal) => {
    return grandTotal > 0 ? ((rowTotal / grandTotal) * 100).toFixed(1) : '0.0';
  };

  const getGrandTotal = (tableData) => {
    return tableData.reduce((total, row) => total + calculateRowTotal(row.values), 0);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.weaveCode.trim()) newErrors.weaveCode = 'Weave Code is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const sessionUserId = localStorage.getItem('sessionUserId');
    if (!sessionUserId) {
      setErrors({ general: 'User session not found. Please log in again.' });
      return;
    }

    const fabricWeightCents = formData.fabricWeight
      ? String(parseInt(formData.fabricWeight, 10) * 100)
      : '';

    const warpDensityInt = toScaledInt(densityInputs.warpDensityWhole, densityInputs.warpDensityDecimal);
    const weftDensityInt = toScaledInt(densityInputs.weftDensityWhole, densityInputs.weftDensityDecimal);
    const submittedTotalThreads = isEdit || totalThreadsEditedByUser
      ? formData.totalThreads
      : calculateTotalThreadsFromFields();

    // Keep explicit null for "remove image" in edit mode.
    // If form state is unexpectedly empty but preview exists, use preview as fallback.
    const resolveImageField = (fieldValue, previewValue, refValue) => {
      if (fieldValue === null || refValue === null) return null;
      if (typeof fieldValue === 'string' && fieldValue.trim()) return fieldValue;
      if (typeof refValue === 'string' && refValue.trim()) return refValue;
      if (typeof previewValue === 'string' && previewValue.trim()) return previewValue;
      return '';
    };

    const normalizedPhoto = resolveImageField(
      formData.photo,
      imagePreview,
      latestImagesRef.current.photo,
    );
    const normalizedPhotoWeave = resolveImageField(
      formData.photoWeave,
      imagePreviewWeave,
      latestImagesRef.current.photoWeave,
    );

    const weaveData = {
      SessionUserId: sessionUserId,
      WeaveCode: formData.weaveCode.trim(),
      Description: formData.description.trim(),
      WarpDensity: warpDensityInt,
      WeftDensity: weftDensityInt,
      ReedWidth: formData.reedWidth || "",
      ReedNo: formData.reedNo || "",
      Dgts: formData.dgts || "",
      PrdCompositionGuid: formData.prdCompositionGuid,
      PrdWeaveTypeGuid: formData.prdWeaveTypeGuid,
      FabricWidth: formData.fabricWidth || "",
      FabricWeight: fabricWeightCents,
      TotalThreads: submittedTotalThreads || "",
      Photo: normalizedPhoto,
      PhotoWeave: normalizedPhotoWeave
    };

    // Add edit-only fields when in edit mode
    if (isEdit) {
      weaveData.WeaveId = initialData?.WeaveId;
    }

    const sortedWarpTableData = removeSourceIndex(warpTableData);
    const sortedWeftTableData = removeSourceIndex(weftTableData);

    // Prepare combined table data with ThreadType and weight
    const allTableData = [
      ...sortedWarpTableData.map(row => ({ ...row, threadType: 2 })), // ThreadType 2 for warp
      ...sortedWeftTableData.map(row => ({ ...row, threadType: 1 }))  // ThreadType 1 for weft
    ];

    const weaveFactorRowsByThreadType = {
      1: Array.isArray(pendingWeaveFactorRowsByThreadType?.[1])
        ? pendingWeaveFactorRowsByThreadType[1]
        : (loadedWeaveFactorRowsByThreadType?.[1] || []),
      2: Array.isArray(pendingWeaveFactorRowsByThreadType?.[2])
        ? pendingWeaveFactorRowsByThreadType[2]
        : (loadedWeaveFactorRowsByThreadType?.[2] || [])
    };

    onSubmit({
      weaveData,
      warpTableData: sortedWarpTableData,
      weftTableData: sortedWeftTableData,
      warpTableColumns,
      weftTableColumns,
      allTableData,
      weaveFactorRowsByThreadType
    });
  };

  const getCompositions = () => {
    if (!dropdownData.Compositions) return [];
    return dropdownData.Compositions.map(item => ({
      Guid: item.PrdCompositionGuid,
      Name: item.ThreadName
    }));
  };

  const getWeaveTypes = () => {
    if (!dropdownData.WeaveTypes) return [];
    return dropdownData.WeaveTypes.map(item => ({
      Guid: item.PrdWeaveTypeGuid,
      Name: item.WeaveTypeName
    }));
  };

  const getYarns = () => {
    if (!dropdownData.Yarns) return [];
    return dropdownData.Yarns.map(item => ({
      Guid: item.PrdYarnGuid,
      Name: item.YarnCode ? `${item.YarnCode} - ${item.YarnName}` : item.YarnName,
      YarnFactor: parseNumeric(item.YarnFactor)
    }));
  };

  const renderSelect = (label, name, list, value, onAdd = null, addTitle = '') => (
    <>
      <CFormLabel htmlFor={name}>{t(label)}</CFormLabel>
      {onAdd ? (
        <CInputGroup className="quick-create-select-group">
          <SearchableSelect
            id={name}
            name={name}
            options={list}
            value={value}
            onChange={(selectedValue) => handleInputChange({ target: { name, value: selectedValue } })}
            onSearchTermChange={(searchTerm) => handleDropdownSearch(name, searchTerm)}
            placeholder={t('Select...')}
            disabled={isLoading || loadingDropdowns}
            invalid={!!errors[name]}
            displayKey="Name"
            valueKey="Guid"
            emptyText={t('No options found')}
            className="quick-create-searchable-select"
          />
          <CButton
            type="button"
            color="success"
            variant="outline"
            onClick={onAdd}
            disabled={isLoading || loadingDropdowns}
            title={addTitle}
          >
            <CIcon icon={cilPlus} />
          </CButton>
        </CInputGroup>
      ) : (
        <SearchableSelect
          id={name}
          name={name}
          options={list}
          value={value}
          onChange={(selectedValue) => handleInputChange({ target: { name, value: selectedValue } })}
          placeholder={t('Select...')}
          disabled={isLoading || loadingDropdowns}
          invalid={!!errors[name]}
          displayKey="Name"
          valueKey="Guid"
          emptyText={t('No options found')}
        />
      )}
      {errors[name] && <div className="invalid-feedback d-block">{errors[name]}</div>}
    </>
  );

  const renderTable = (isWarp) => {
    const rawTableData = isWarp ? warpTableData : weftTableData;
    const tableData = rawTableData;
    const tableColumns = isWarp ? warpTableColumns : weftTableColumns;
    const colorOptions = colorList.map((color) => ({
      ...color,
      ColorDisplay: color?.ColorCode
        ? `${color?.ColorName || ''} - ${color.ColorCode}`
        : (color?.ColorName || '')
    }));
    const yarnOptions = getYarns();
    const threadType = isWarp ? 2 : 1;
    const factorRows = getFactorRowsForThreadType(threadType, true);

    const getFactorRangeForColumn = (columnNo) => {
      return factorRows.find(range => columnNo >= range.start && columnNo <= range.end) || null;
    };

    const getWeightedCellValue = (row, colIndex) => {
      const threadCount = parseInt(row.values[colIndex], 10) || 0;
      const factor = getColumnFactorForThreadType(threadType, colIndex + 1);
      return threadCount * factor;
    };

    const getWeightedRowTotal = (row) => {
      return getWeightedRowTotalForThreadType(row, threadType);
    };

    const grandTotal = tableData.reduce((sum, row) => sum + getWeightedRowTotal(row), 0);

    return (
      <div className="weave-table-container">
        <CTable responsive className="weave-table mb-0">
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell className="color-column">
                <div className="header-with-action">
                  <span>{t('colorName')}</span>
                  <CButton
                    type="button"
                    size="sm"
                    color="primary"
                    variant="outline"
                    className="header-add-btn"
                    onClick={handleOpenAddColorModal}
                    title={t('createColor') || 'Renk Ekle'}
                  >
                    <CIcon icon={cilPlus} size="sm" />
                  </CButton>
                </div>
              </CTableHeaderCell>
              <CTableHeaderCell className="code-column">{t('colorNumber')}</CTableHeaderCell>
              <CTableHeaderCell className="yarn-column">
                <div className="header-with-action">
                  <span>{t('yarnNumber')}</span>
                  <CButton
                    type="button"
                    size="sm"
                    color="primary"
                    variant="outline"
                    className="header-add-btn"
                    onClick={handleOpenAddYarnModal}
                    title={t('createYarn') || 'Iplik Ekle'}
                  >
                    <CIcon icon={cilPlus} size="sm" />
                  </CButton>
                </div>
              </CTableHeaderCell>
              {Array.from({ length: tableColumns }, (_, i) => {
                const columnNo = i + 1;
                const factorRange = getFactorRangeForColumn(columnNo);
                return (
                  <CTableHeaderCell
                    key={i}
                    className="number-column"
                    style={factorRange ? { backgroundColor: factorRange.backgroundColor } : undefined}
                  >
                    {columnNo}
                  </CTableHeaderCell>
                );
              })}
              <CTableHeaderCell className="total-column">{t('total')}</CTableHeaderCell>
              <CTableHeaderCell className="percent-column">{t('percent')}</CTableHeaderCell>
              {isEdit && (
                <CTableHeaderCell className="weight-column">
                  {isWarp ? t('warpWeight') : t('weftWeight')}
                </CTableHeaderCell>
              )}
              <CTableHeaderCell className="action-column">{t('action')}</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {tableData.map((row, rowIndex) => {
              const sourceRowIndex = row.sourceIndex >= 0 ? row.sourceIndex : rowIndex;
              const rowTotal = getWeightedRowTotal(row);
              const rowPercentage = calculateRowPercentage(rowTotal, grandTotal);

              return (
                <CTableRow key={row.id} className="slide-up">
                  <CTableDataCell className="color-column">
                    <SearchableSelect
                      options={colorOptions}
                      value={row.colorId}
                      onChange={(selectedValue) => handleColorSelection(sourceRowIndex, selectedValue, isWarp)}
                      placeholder={t('selectColor')}
                      size="sm"
                      displayKey="ColorDisplay"
                      valueKey="ColorId"
                      searchKeys={['ColorName', 'ColorCode']}
                      emptyText={t('No colors found')}
                      className="weave-table"
                    />
                  </CTableDataCell>
                  <CTableDataCell className="code-column">
                    <span className="color-code">{row.colorCode || '-'}</span>
                  </CTableDataCell>
                  <CTableDataCell className="yarn-column">
                    <SearchableSelect
                      options={yarnOptions}
                      value={row.yarnId}
                      onChange={(selectedValue) => handleYarnSelection(sourceRowIndex, selectedValue, isWarp)}
                      placeholder={t('selectYarn')}
                      size="sm"
                      displayKey="Name"
                      valueKey="Guid"
                      emptyText={t('No yarns found')}
                      className="weave-table"
                    />
                  </CTableDataCell>
                  {row.values.map((value, colIndex) => {
                    const factorRange = getFactorRangeForColumn(colIndex + 1);
                    const hasOtherValueInColumn = hasValueInOtherRowForColumn(tableData, rowIndex, colIndex);
                    const currentCellValue = parseInt(value, 10) || 0;
                    const isLockedByColumnRule = hasOtherValueInColumn && currentCellValue <= 0;
                    return (
                    <CTableDataCell
                      key={colIndex}
                      className="number-column"
                      style={factorRange ? { backgroundColor: factorRange.backgroundColor } : undefined}
                    >
                      <CFormInput
                        type="number"
                        size="sm"
                        value={currentCellValue > 0 ? value : ''}//0 yerine '' gösteriyor
                        onChange={(e) => handleCellValueChange(sourceRowIndex, colIndex, e.target.value, isWarp)}
                        onKeyDown={(e) => handleCellKeyDown(e, rowIndex, colIndex, isWarp, tableData.length, tableColumns)}
                        className="table-input"
                        data-table-type={isWarp ? 'warp' : 'weft'}
                        data-row-index={rowIndex}
                        data-col-index={colIndex}
                        min="0"
                        placeholder=""
                        disabled={isLockedByColumnRule}
                      />
                    </CTableDataCell>
                    );
                  })}
                  <CTableDataCell className="total-column">
                    <strong>{rowTotal > 0 ? rowTotal : ''}</strong>
                  </CTableDataCell>
                  <CTableDataCell className="percent-column">
                    <strong>{rowTotal > 0 && grandTotal > 0 ? `${rowPercentage}%` : ''}</strong>
                  </CTableDataCell>
                  {isEdit && (
                    <CTableDataCell className="weight-column">
                      <CFormInput
                        type="text"
                        size="sm"
                        value={formatWeight(row.weight, isWarp ? 2 : 1)}
                        className="table-input"
                        placeholder="0.00"
                        readOnly
                      />
                    </CTableDataCell>
                  )}
                  <CTableDataCell className="action-column">
                    <CButton
                      size="sm"
                      color="danger"
                      variant="outline"
                      onClick={() => removeRow(sourceRowIndex, isWarp)}
                      disabled={tableData.length <= 1}
                      title={t('removeRow')}
                    >
                      <CIcon icon={cilMinus} size="sm" />
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              );
            })}
            <CTableRow className="total-row">
              <CTableDataCell colSpan={3} className="text-end pe-3 sticky-summary-label">
                <strong>{t('totalLabel')}</strong>
              </CTableDataCell>
              {Array.from({ length: tableColumns }, (_, colIndex) => {
                const factorRange = getFactorRangeForColumn(colIndex + 1);
                const columnTotal = tableData.reduce((sum, row) => sum + getWeightedCellValue(row, colIndex), 0);
                return (
                  <CTableDataCell
                    key={colIndex}
                    className="number-column"
                    style={factorRange ? { backgroundColor: factorRange.backgroundColor } : undefined}
                  >
                    <strong>{columnTotal > 0 ? columnTotal : ''}</strong>
                  </CTableDataCell>
                );
              })}
              <CTableDataCell className="total-column">
                <strong>{grandTotal > 0 ? grandTotal : ''}</strong>
              </CTableDataCell>
              <CTableDataCell className="percent-column">
                <strong>{grandTotal > 0 ? '100.0%' : ''}</strong>
              </CTableDataCell>
              {isEdit && (
                <CTableDataCell className="weight-column"></CTableDataCell>
              )}
              <CTableDataCell className="action-column"></CTableDataCell>
            </CTableRow>

            {factorRows.length > 0 && (
              <CTableRow className="factor-row">
                <CTableDataCell colSpan={3} className="text-end pe-3 sticky-summary-label">
                  <strong>{t('factor') || 'Carpan'}</strong>
                </CTableDataCell>
                {Array.from({ length: tableColumns }, (_, colIndex) => {
                  const columnNo = colIndex + 1;
                  const factorRange = getFactorRangeForColumn(columnNo);
                  const midpointColumn = factorRange
                    ? Math.round((Number(factorRange.start) + Number(factorRange.end)) / 2)
                    : -1;
                  const label = factorRange && columnNo === midpointColumn
                    ? `X${factorRange.factor}`
                    : '';

                  return (
                    <CTableDataCell
                      key={`factor-${columnNo}`}
                      className="number-column text-center factor-cell"
                      style={factorRange ? { backgroundColor: factorRange.backgroundColor } : undefined}
                    >
                      <strong>{label}</strong>
                    </CTableDataCell>
                  );
                })}
                <CTableDataCell className="total-column"></CTableDataCell>
                <CTableDataCell className="percent-column"></CTableDataCell>
                {isEdit && (
                  <CTableDataCell className="weight-column"></CTableDataCell>
                )}
                <CTableDataCell className="action-column"></CTableDataCell>
              </CTableRow>
            )}
          </CTableBody>
        </CTable>
      </div>
    );
  };

  return (
    <div className="weave-inputs-container">
      {errors.general && (
        <CAlert color="danger" dismissible onClose={() => setErrors(prev => ({ ...prev, general: '' }))}>
          {errors.general}
        </CAlert>
      )}

      {quickCreateFeedback.message && (
        <CAlert
          color={quickCreateFeedback.type === 'success' ? 'success' : 'danger'}
          dismissible
          onClose={() => setQuickCreateFeedback({ type: '', message: '' })}
        >
          {quickCreateFeedback.message}
        </CAlert>
      )}

      {submitResponse && submitResponse.Result && submitResponse.Result.ErrorCode !== 0 && submitResponse.Result.ErrorDescription && (
        <CAlert color="danger">
          {submitResponse.Result.ErrorDescription}
        </CAlert>
      )}

      {loadingWeaveColors && (
        <CAlert color="info" className="d-flex align-items-center">
          <CSpinner size="sm" className="me-2" />
          Loading weave colors...
        </CAlert>
      )}

      <CForm onSubmit={handleSubmit}>
        <CCard className="weave-form-card mb-4">
          <CCardHeader className="weave-form-header">
            <h5>{t('weaveInformation')}</h5>
          </CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={4}>
                <CFormLabel htmlFor="weaveCode">{t('weaveCodeTip')} *</CFormLabel>
                <CFormInput
                  type="text"
                  id="weaveCode"
                  name="weaveCode"
                  value={formData.weaveCode}
                  onChange={handleInputChange}
                  invalid={!!errors.weaveCode}
                  disabled={isLoading}
                  placeholder={t('enterWeaveName')}
                />
                {errors.weaveCode && <div className="invalid-feedback d-block">{errors.weaveCode}</div>}
              </CCol>
              <CCol md={4}>
                {renderSelect(
                  "composition",
                  "prdCompositionGuid",
                  getCompositions(),
                  formData.prdCompositionGuid,
                  handleOpenAddCompositionModal,
                  t('createComposition') || 'Kompozisyon Ekle'
                )}
              </CCol>
              <CCol md={4}>
                {renderSelect(
                  "weaveType",
                  "prdWeaveTypeGuid",
                  getWeaveTypes(),
                  formData.prdWeaveTypeGuid,
                  handleOpenAddWeaveTypeModal,
                  t('createWeaveType') || 'Orgu Tipi Ekle'
                )}
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={3}>
                <CFormLabel htmlFor="warpDensity">{t('warpDensity')}</CFormLabel>
                <div className="fabric-weight-input-group">
                  <div className="weight-input-section">
                    <CFormInput
                      type="text"
                      id="warpDensityWhole"
                      className="weight-whole"
                      value={densityInputs.warpDensityWhole}
                      onChange={(e) => handleDensityInputChange('warp', 'whole', e.target.value)}
                      onKeyDown={(e) => handleDensityKeyDown(e, 'warp', 'whole')}
                      disabled={isLoading}
                      placeholder="0"
                    />
                    <span className="decimal-separator">,</span>
                    <CFormInput
                      type="text"
                      id="warpDensityDecimal"
                      className="weight-decimal"
                      value={densityInputs.warpDensityDecimal}
                      onChange={(e) => handleDensityInputChange('warp', 'decimal', e.target.value)}
                      onKeyDown={(e) => handleDensityKeyDown(e, 'warp', 'decimal')}
                      onBlur={() => handleDensityBlur('warp', 'decimal')}
                      disabled={isLoading}
                      placeholder="00"
                    />
                  </div>
                </div>
              </CCol>
              <CCol md={3}>
                <CFormLabel htmlFor="weftDensity">{t('weftDensity')}</CFormLabel>
                <div className="fabric-weight-input-group">
                  <div className="weight-input-section">
                    <CFormInput
                      type="text"
                      id="weftDensityWhole"
                      className="weight-whole"
                      value={densityInputs.weftDensityWhole}
                      onChange={(e) => handleDensityInputChange('weft', 'whole', e.target.value)}
                      onKeyDown={(e) => handleDensityKeyDown(e, 'weft', 'whole')}
                      disabled={isLoading}
                      placeholder="0"
                    />
                    <span className="decimal-separator">,</span>
                    <CFormInput
                      type="text"
                      id="weftDensityDecimal"
                      className="weight-decimal"
                      value={densityInputs.weftDensityDecimal}
                      onChange={(e) => handleDensityInputChange('weft', 'decimal', e.target.value)}
                      onKeyDown={(e) => handleDensityKeyDown(e, 'weft', 'decimal')}
                      onBlur={() => handleDensityBlur('weft', 'decimal')}
                      disabled={isLoading}
                      placeholder="00"
                    />
                  </div>
                </div>
              </CCol>
              <CCol md={3}>
                <CFormLabel htmlFor="reedWidth">{t('reedWidth')}</CFormLabel>
                <CFormInput
                  type="number"
                  id="reedWidth"
                  name="reedWidth"
                  value={formData.reedWidth}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  placeholder={t('Optional')}
                />
              </CCol>
              <CCol md={3}>
                <CFormLabel htmlFor="reedNo">{t('reedNo')}</CFormLabel>
                <CFormInput
                  type="number"
                  id="reedNo"
                  name="reedNo"
                  value={formData.reedNo}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  placeholder={t('Optional')}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4}>
                <CFormLabel htmlFor="dgts">{t('dgts')}</CFormLabel>
                <CFormInput
                  type="text"
                  id="dgts"
                  name="dgts"
                  value={formData.dgts}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  placeholder={t('Optional')}
                />
              </CCol>
              <CCol md={4}>
                <CFormLabel htmlFor="fabricWidth">{t('grayFabricWidth')}</CFormLabel>
                <CFormInput
                  type="number"
                  id="fabricWidth"
                  name="fabricWidth"
                  value={formData.fabricWidth}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  placeholder={t('Optional')}
                  min="0"
                  step="0.01"
                />
              </CCol>
              <CCol md={4}>
                <CFormLabel htmlFor="fabricWeight">{t('grayFabricWeight')}</CFormLabel>
                <CFormInput
                  type="text"
                  id="fabricWeight"
                  name="fabricWeight"
                  value={formData.fabricWeight}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) handleInputChange(e);
                  }}
                  placeholder="0"
                  disabled={isLoading}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={6}>
                <CFormLabel htmlFor="insertDatetime">{t('insertDatetime')}</CFormLabel>
                <CFormInput
                  type="text"
                  id="insertDatetime"
                  name="insertDatetime"
                  value={initialData?.InsertDatetime ? formatDateOnly(new Date(initialData.InsertDatetime)) : formatDateOnly(new Date())}
                  disabled={true}
                  className="form-control-plaintext"
                />
              </CCol>
              <CCol md={6}>
                <CFormLabel htmlFor="totalThreads">{t('totalThreads')}</CFormLabel>
                <CFormInput
                  type="text"
                  id="totalThreads"
                  name="totalThreads"
                  value={formData.totalThreads}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) handleInputChange(e);
                  }}
                  disabled={isLoading}
                  placeholder={t('Optional')}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={12}>
                <CFormLabel htmlFor="description">{t('description')}</CFormLabel>
                <CFormTextarea
                  id="description"
                  name="description"
                  rows={3}
                  value={formData.description}
                  onChange={handleInputChange}
                  invalid={!!errors.description}
                  disabled={isLoading}
                  placeholder={t('enterDescription')}
                />
                {errors.description && (
                  <div className="invalid-feedback d-block">{errors.description}</div>
                )}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Weave Type Tabs */}
        {showSaveButton && (
          <CCard className="weave-tabs-card fade-in">
            <CCardHeader className="tabs-header">
              <CNav variant="tabs" role="tablist" className="weave-tabs">
                <CNavItem>
                  <CNavLink
                    active={activeTab === 'cozgu'}
                    onClick={() => setActiveTab('cozgu')}
                    className="weave-tab-link"
                  >
                    <CIcon icon={cilColorPalette} className="me-2" />
                    {t('warp')}
                  </CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink
                    active={activeTab === 'atki'}
                    onClick={() => setActiveTab('atki')}
                    className="weave-tab-link"
                  >
                    <CIcon icon={cilGrid} className="me-2" />
                    {t('weft')}
                  </CNavLink>
                </CNavItem>
              </CNav>

              <div className="tabs-photo-upload">
                <div className="image-upload-section compact-image-upload">
                  <div className="compact-image-row">
                    <div className="compact-image-label">{t('fabricPhoto') || 'Kumaş Fotoğrafı'}</div>
                    <div className="image-upload-container" onClick={() => handleImageClick('photoWeave')}>
                      {imagePreviewWeave ? (
                        <div className="image-preview-wrapper">
                          <img
                            src={imagePreviewWeave}
                            alt="Weave Detail"
                            className="image-preview"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenImageModal(imagePreviewWeave, t('fabricPhoto') || 'Kumaş Fotoğrafı');
                            }}
                          />
                          <CButton
                            color="danger"
                            size="sm"
                            className="remove-image-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveImage('photoWeave');
                            }}
                          >
                            <CIcon icon={cilX} />
                          </CButton>
                        </div>
                      ) : (
                        <div className="upload-placeholder">
                          <CIcon icon={cilImage} size="xl" />
                          <span>{t('selectImage') || 'Gorsel sec'}</span>
                          <span className="upload-hint">400x400 / 350x200</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="compact-image-row">
                    <div className="compact-image-label">{t('armurePhoto') || 'Armür Fotoğrafı'}</div>
                    <div className="image-upload-container" onClick={() => handleImageClick('photo')}>
                      {imagePreview ? (
                        <div className="image-preview-wrapper">
                          <img
                            src={imagePreview}
                            alt="Weave"
                            className="image-preview"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenImageModal(imagePreview, t('armurePhoto') || 'Armür Fotoğrafı');
                            }}
                          />
                          <CButton
                            color="danger"
                            size="sm"
                            className="remove-image-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveImage('photo');
                            }}
                          >
                            <CIcon icon={cilX} />
                          </CButton>
                        </div>
                      ) : (
                        <div className="upload-placeholder">
                          <CIcon icon={cilImage} size="xl" />
                          <span>{t('selectImage') || 'Gorsel sec'}</span>
                          <span className="upload-hint">400x400</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <input
                    ref={armureFileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageSelect(e, 'photo')}
                    style={{ display: 'none' }}
                  />
                  <input
                    ref={weaveFileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageSelect(e, 'photoWeave')}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>

              {/* Enhanced Table Controls with Bulk Add */}
              <div className="table-controls">
                <div className="bulk-controls-row">
                  {/* Row Controls */}
                  <div className="control-group">
                    <label className="control-label">{t('rows')}:</label>
                    <CInputGroup size="sm" className="bulk-input-group">
                      <CButton
                        size="sm"
                        color="danger"
                        variant="outline"
                        className="left-btn"
                        onClick={() => removeRows(activeTab === 'cozgu', activeTab === 'cozgu' ? bulkAddRows.warp : bulkAddRows.weft)}
                        disabled={(activeTab === 'cozgu' ? warpTableData.length : weftTableData.length) <= 1}
                        title={t('removeRows')}
                      >
                        <CIcon icon={cilMinus} size="sm" />
                      </CButton>
                      <CFormInput
                        type="number"
                        min="1"
                        max="1000"
                        value={activeTab === 'cozgu' ? bulkAddRows.warp : bulkAddRows.weft}
                        onChange={(e) => handleBulkRowsChange(e.target.value, activeTab === 'cozgu')}
                        className="bulk-number-input has-left-button"
                        placeholder="1"
                      />
                      <CButton
                        size="sm"
                        color="success"
                        variant="outline"
                        className="right-btn"
                        onClick={() => addRows(activeTab === 'cozgu', activeTab === 'cozgu' ? bulkAddRows.warp : bulkAddRows.weft)}
                        title={t('addRows')}
                      >
                        <CIcon icon={cilPlus} size="sm" />
                      </CButton>
                    </CInputGroup>
                  </div>

                  {/* Column Controls */}
                  <div className="control-group">
                    <label className="control-label">{t('columns')}:</label>
                    <CInputGroup size="sm" className="bulk-input-group">
                      <CButton
                        size="sm"
                        color="danger"
                        variant="outline"
                        className="left-btn"
                        onClick={() => removeColumns(activeTab === 'cozgu', activeTab === 'cozgu' ? bulkAddColumns.warp : bulkAddColumns.weft)}
                        disabled={(activeTab === 'cozgu' ? warpTableColumns : weftTableColumns) <= 1}
                        title={t('removeColumns')}
                      >
                        <CIcon icon={cilMinus} size="sm" />
                      </CButton>
                      <CFormInput
                        type="number"
                        min="1"
                        max="1000"
                        value={activeTab === 'cozgu' ? bulkAddColumns.warp : bulkAddColumns.weft}
                        onChange={(e) => handleBulkColumnsChange(e.target.value, activeTab === 'cozgu')}
                        className="bulk-number-input has-left-button"
                        placeholder="1"
                      />
                      <CButton
                        size="sm"
                        color="success"
                        variant="outline"
                        className="right-btn"
                        onClick={() => addColumns(activeTab === 'cozgu', activeTab === 'cozgu' ? bulkAddColumns.warp : bulkAddColumns.weft)}
                        title={t('addColumns')}
                      >
                        <CIcon icon={cilPlus} size="sm" />
                      </CButton>
                    </CInputGroup>
                  </div>

                  {/* WeaveFactor Button */}
                  <div className="control-group">
                    <CButton
                      size="sm"
                      color="primary"
                      variant="outline"
                      onClick={handleOpenWeaveFactorModal}
                      title={t('addFactor') || 'Carpan Ekle'}
                    >
                      <CIcon icon={cilPlus} size="sm" /> {t('addFactor') || 'Carpan Ekle'}
                    </CButton>
                  </div>
                </div>
              </div>
            </CCardHeader>

            <CCardBody className="p-0">
              <CTabContent>
                <CTabPane visible={activeTab === 'cozgu'}>
                  {renderTable(true)}
                </CTabPane>

                <CTabPane visible={activeTab === 'atki'}>
                  {renderTable(false)}
                </CTabPane>
              </CTabContent>
            </CCardBody>
          </CCard>
        )}

        {showSaveButton && (
          <CRow>
            <CCol className="d-flex gap-2">
              <CButton type="submit" color="primary" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <CSpinner size="sm" className="me-2" /> {t('saving')}
                  </>
                ) : (
                  <>
                    <CIcon icon={cilSave} className="me-2" /> {t('save')}
                  </>
                )}
              </CButton>
              <CButton color="secondary" variant="outline" onClick={onCancel} disabled={isLoading}>
                <CIcon icon={cilX} className="me-2" /> {t('cancel')}
              </CButton>
            </CCol>
          </CRow>
        )}

        <CModal
          visible={showAddColorModal}
          onClose={() => {
            setShowAddColorModal(false);
            resetAddColorModal();
          }}
          size="lg"
        >
          <CModalHeader>
            <CModalTitle>{t('createColor') || 'Renk Ekle'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {addColorErrors.general && <CAlert color="danger">{addColorErrors.general}</CAlert>}
            <CRow className="g-3">
              <CCol md={6}>
                <CFormLabel>{t('colorName') || 'Renk Adi'} *</CFormLabel>
                <CFormInput
                  value={addColorForm.colorName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddColorForm(prev => ({ ...prev, colorName: value }));
                    if (addColorErrors.colorName) {
                      setAddColorErrors(prev => ({ ...prev, colorName: '' }));
                    }
                  }}
                  invalid={!!addColorErrors.colorName}
                  disabled={addColorLoading}
                />
                {addColorErrors.colorName && <div className="invalid-feedback d-block">{addColorErrors.colorName}</div>}
              </CCol>
              <CCol md={6}>
                <CFormLabel>{t('colorCode') || 'Renk Kodu'}</CFormLabel>
                <CFormInput
                  value={addColorForm.colorCode}
                  onChange={(e) => setAddColorForm(prev => ({ ...prev, colorCode: e.target.value }))}
                  disabled={addColorLoading}
                />
              </CCol>
              <CCol md={12}>
                <CFormLabel>{t('description') || 'Aciklama'}</CFormLabel>
                <CFormTextarea
                  rows={3}
                  value={addColorForm.colorDescription}
                  onChange={(e) => setAddColorForm(prev => ({ ...prev, colorDescription: e.target.value }))}
                  disabled={addColorLoading}
                />
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton
              type="button"
              color="secondary"
              variant="outline"
              onClick={() => {
                setShowAddColorModal(false);
                resetAddColorModal();
              }}
              disabled={addColorLoading}
            >
              <CIcon icon={cilX} className="me-1" /> {t('cancel') || 'Iptal'}
            </CButton>
            <CButton type="button" color="primary" onClick={handleAddColorSubmit} disabled={addColorLoading}>
              {addColorLoading ? <><CSpinner size="sm" className="me-1" />{t('saving') || 'Kaydediliyor...'}</> : <><CIcon icon={cilSave} className="me-1" /> {t('save') || 'Kaydet'}</>}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={showAddCompositionModal}
          onClose={() => {
            setShowAddCompositionModal(false);
            resetAddCompositionModal();
          }}
          size="lg"
        >
          <CModalHeader>
            <CModalTitle>{t('createComposition') || 'Kompozisyon Ekle'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {addCompositionErrors.general && <CAlert color="danger">{addCompositionErrors.general}</CAlert>}
            <CRow className="g-3">
              <CCol md={12}>
                <CFormLabel>{t('threadCompositionName') || 'Kompozisyon Adi'} *</CFormLabel>
                <CFormInput
                  value={addCompositionForm.threadName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddCompositionForm(prev => ({ ...prev, threadName: value }));
                    if (addCompositionErrors.threadName) {
                      setAddCompositionErrors(prev => ({ ...prev, threadName: '' }));
                    }
                  }}
                  invalid={!!addCompositionErrors.threadName}
                  disabled={addCompositionLoading}
                />
                {addCompositionErrors.threadName && (
                  <div className="invalid-feedback d-block">{addCompositionErrors.threadName}</div>
                )}
              </CCol>
              <CCol md={12}>
                <CFormLabel>{t('threadCompositionDescription') || 'Aciklama'}</CFormLabel>
                <CFormTextarea
                  rows={3}
                  value={addCompositionForm.threadDescription}
                  onChange={(e) => setAddCompositionForm(prev => ({
                    ...prev,
                    threadDescription: e.target.value
                  }))}
                  disabled={addCompositionLoading}
                />
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton
              type="button"
              color="secondary"
              variant="outline"
              onClick={() => {
                setShowAddCompositionModal(false);
                resetAddCompositionModal();
              }}
              disabled={addCompositionLoading}
            >
              <CIcon icon={cilX} className="me-1" /> {t('cancel') || 'Iptal'}
            </CButton>
            <CButton
              type="button"
              color="primary"
              onClick={handleAddCompositionSubmit}
              disabled={addCompositionLoading}
            >
              {addCompositionLoading
                ? <><CSpinner size="sm" className="me-1" />{t('saving') || 'Kaydediliyor...'}</>
                : <><CIcon icon={cilSave} className="me-1" /> {t('save') || 'Kaydet'}</>}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={showAddWeaveTypeModal}
          onClose={() => {
            setShowAddWeaveTypeModal(false);
            resetAddWeaveTypeModal();
          }}
          size="lg"
        >
          <CModalHeader>
            <CModalTitle>{t('createWeaveType') || 'Orgu Tipi Ekle'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {addWeaveTypeErrors.general && <CAlert color="danger">{addWeaveTypeErrors.general}</CAlert>}
            <CRow className="g-3">
              <CCol md={12}>
                <CFormLabel>{t('weaveTypeName') || 'Orgu Tipi Adi'} *</CFormLabel>
                <CFormInput
                  value={addWeaveTypeForm.weaveTypeName}
                  onChange={(e) => {
                    setAddWeaveTypeForm(prev => ({ ...prev, weaveTypeName: e.target.value }));
                    if (addWeaveTypeErrors.weaveTypeName) {
                      setAddWeaveTypeErrors(prev => ({ ...prev, weaveTypeName: '' }));
                    }
                  }}
                  invalid={!!addWeaveTypeErrors.weaveTypeName}
                  disabled={addWeaveTypeLoading}
                />
                {addWeaveTypeErrors.weaveTypeName && (
                  <div className="invalid-feedback d-block">{addWeaveTypeErrors.weaveTypeName}</div>
                )}
              </CCol>
              <CCol md={12}>
                <CFormLabel>{t('Description') || 'Aciklama'}</CFormLabel>
                <CFormTextarea
                  rows={3}
                  value={addWeaveTypeForm.weaveTypeDescription}
                  onChange={(e) => setAddWeaveTypeForm(prev => ({
                    ...prev,
                    weaveTypeDescription: e.target.value
                  }))}
                  disabled={addWeaveTypeLoading}
                />
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton
              type="button"
              color="secondary"
              variant="outline"
              onClick={() => {
                setShowAddWeaveTypeModal(false);
                resetAddWeaveTypeModal();
              }}
              disabled={addWeaveTypeLoading}
            >
              <CIcon icon={cilX} className="me-1" /> {t('cancel') || 'Iptal'}
            </CButton>
            <CButton type="button" color="primary" onClick={handleAddWeaveTypeSubmit} disabled={addWeaveTypeLoading}>
              {addWeaveTypeLoading
                ? <><CSpinner size="sm" className="me-1" />{t('saving') || 'Kaydediliyor...'}</>
                : <><CIcon icon={cilSave} className="me-1" /> {t('save') || 'Kaydet'}</>}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={showAddYarnModal}
          onClose={() => {
            setShowAddYarnModal(false);
            resetAddYarnModal();
          }}
          size="lg"
        >
          <CModalHeader>
            <CModalTitle>{t('createYarn') || 'Iplik Ekle'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {addYarnErrors.general && <CAlert color="danger">{addYarnErrors.general}</CAlert>}
            <CRow className="g-3">
              <CCol md={4}>
                <CFormLabel>{t('yarnCode') || 'Iplik Kodu'} *</CFormLabel>
                <CFormInput
                  value={addYarnForm.yarnCode}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddYarnForm(prev => ({ ...prev, yarnCode: value }));
                    if (addYarnErrors.yarnCode) {
                      setAddYarnErrors(prev => ({ ...prev, yarnCode: '' }));
                    }
                  }}
                  invalid={!!addYarnErrors.yarnCode}
                  disabled={addYarnLoading}
                />
                {addYarnErrors.yarnCode && <div className="invalid-feedback d-block">{addYarnErrors.yarnCode}</div>}
              </CCol>
              <CCol md={4}>
                <CFormLabel>{t('yarnName') || 'Iplik Adi'}</CFormLabel>
                <CFormInput
                  value={addYarnForm.yarnName}
                  onChange={(e) => setAddYarnForm(prev => ({ ...prev, yarnName: e.target.value }))}
                  disabled={addYarnLoading}
                />
              </CCol>
              <CCol md={4}>
                <CFormLabel>{t('yarnType') || 'Iplik Tipi'} *</CFormLabel>
                <CFormSelect
                  value={addYarnForm.yarnType}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddYarnForm(prev => ({ ...prev, yarnType: value }));
                    if (addYarnErrors.yarnType) {
                      setAddYarnErrors(prev => ({ ...prev, yarnType: '' }));
                    }
                  }}
                  invalid={!!addYarnErrors.yarnType}
                  disabled={addYarnLoading}
                >
                  <option value="">{t('selectYarnType') || 'Iplik tipi secin'}</option>
                  {yarnTypeOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </CFormSelect>
                {addYarnErrors.yarnType && <div className="invalid-feedback d-block">{addYarnErrors.yarnType}</div>}
              </CCol>
              <CCol md={12}>
                <CFormLabel>{t('description') || 'Aciklama'}</CFormLabel>
                <CFormTextarea
                  rows={3}
                  value={addYarnForm.yarnDescription}
                  onChange={(e) => setAddYarnForm(prev => ({ ...prev, yarnDescription: e.target.value }))}
                  disabled={addYarnLoading}
                />
              </CCol>
            </CRow>
          </CModalBody>
          <CModalFooter>
            <CButton
              type="button"
              color="secondary"
              variant="outline"
              onClick={() => {
                setShowAddYarnModal(false);
                resetAddYarnModal();
              }}
              disabled={addYarnLoading}
            >
              <CIcon icon={cilX} className="me-1" /> {t('cancel') || 'Iptal'}
            </CButton>
            <CButton type="button" color="primary" onClick={handleAddYarnSubmit} disabled={addYarnLoading}>
              {addYarnLoading ? <><CSpinner size="sm" className="me-1" />{t('saving') || 'Kaydediliyor...'}</> : <><CIcon icon={cilSave} className="me-1" /> {t('save') || 'Kaydet'}</>}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          visible={imageModal}
          onClose={() => {
            setImageModal(false);
            setImageModalSrc(null);
            setImageModalTitle('');
          }}
          size="xl"
          fullscreen
          alignment="center"
          className="image-preview-modal"
        >
          <CModalHeader closeButton>
            <CModalTitle>{imageModalTitle || (t('sampleImage') || 'Tip Fotografi')}</CModalTitle>
          </CModalHeader>
          <CModalBody
            className="text-center p-0"
            style={{
              background: '#000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 'calc(100vh - 120px)'
            }}
          >
            {imageModalSrc && (
              <img
                src={imageModalSrc}
                alt="Weave"
                className="preview-image"
                style={{
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain'
                }}
              />
            )}
          </CModalBody>
        </CModal>

        <CModal
          visible={cropModalVisible}
          onClose={handleCropCancel}
          size="lg"
          alignment="center"
          backdrop="static"
          className="crop-modal"
        >
          <CModalHeader closeButton>
            <CModalTitle>Gorseli Kirp {imageDimensions.width > 0 && `- ${imageDimensions.width} x ${imageDimensions.height}`}</CModalTitle>
          </CModalHeader>
          <CModalBody className="p-0">
            <div className="crop-container">
              {cropImageSrc && !cropSkipped && (
                <Cropper
                  image={cropImageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={activeCropPreset.aspect}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                  showGrid={true}
                />
              )}
              {cropImageSrc && cropSkipped && (
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                  <img
                    src={cropImageSrc}
                    alt="Original"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
              )}
            </div>
            <div className="crop-controls">
              {cropTargetField === 'photoWeave' && !cropSkipped && (
                <div className="crop-size-options">
                  <span>Boyut:</span>
                  <CButton
                    type="button"
                    size="sm"
                    color={weaveCropPresetKey === 'square400' ? 'primary' : 'secondary'}
                    variant={weaveCropPresetKey === 'square400' ? undefined : 'outline'}
                    onClick={() => {
                      setWeaveCropPresetKey('square400');
                      setCrop({ x: 0, y: 0 });
                      setZoom(1);
                    }}
                  >
                    400x400
                  </CButton>
                  <CButton
                    type="button"
                    size="sm"
                    color={weaveCropPresetKey === 'wide350x200' ? 'primary' : 'secondary'}
                    variant={weaveCropPresetKey === 'wide350x200' ? undefined : 'outline'}
                    onClick={() => {
                      setWeaveCropPresetKey('wide350x200');
                      setCrop({ x: 0, y: 0 });
                      setZoom(1);
                    }}
                  >
                    350x200
                  </CButton>
                </div>
              )}
              <div className="zoom-control">
                {!cropSkipped && (
                  <>
                    <CButton type="button" color="info" variant="outline" size="sm" onClick={handleCropSkip}>
                      Kırpmayı Atla
                    </CButton>
                    <label>Yakinlastir:</label>
                    <input
                      type="range"
                      min={1}
                      max={3}
                      step={0.1}
                      value={zoom}
                      onChange={(e) => setZoom(Number(e.target.value))}
                      className="zoom-slider"
                    />
                  </>
                )}
                {cropSkipped && (
                  <CButton type="button" color="info" variant="outline" size="sm" onClick={() => setCropSkipped(false)}>
                    Tekrar Kirp
                  </CButton>
                )}
              </div>
              <div className="crop-actions">
                <CButton type="button" color="secondary" onClick={handleCropCancel}>
                  Iptal
                </CButton>
                <CButton type="button" color="primary" onClick={handleCropConfirm}>
                  <CIcon icon={cilSave} className="me-1" />
                  {cropSkipped ? 'Kaydet' : 'Kirp ve Kaydet'}
                </CButton>
              </div>
            </div>
          </CModalBody>
        </CModal>

        <CModal visible={showWeaveFactorModal} onClose={handleCloseWeaveFactorModal} size="lg">
          <CModalHeader>
            <CModalTitle>{t('addFactor') || 'Carpan Ekle'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <span className="me-2">{t('threadType') || 'Iplik Tipi'}:</span>
                <CBadge color="primary">{getCurrentThreadType() === 2 ? (t('warp') || 'Cozgu') : (t('weft') || 'Atki')}</CBadge>
              </div>
              <CButton color="success" variant="outline" size="sm" onClick={handleAddWeaveFactorRow}>
                <CIcon icon={cilPlus} className="me-1" /> {t('addRow') || 'Satir Ekle'}
              </CButton>
            </div>

            {weaveFactorModalError && <CAlert color="danger">{weaveFactorModalError}</CAlert>}

            {weaveFactorModalLoading ? (
              <div className="d-flex align-items-center">
                <CSpinner size="sm" className="me-2" />
                <span>{t('loading') || 'Yukleniyor...'}</span>
              </div>
            ) : (
              <CTable bordered responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>{t('firstColumn') || 'Ilk Sutun'}</CTableHeaderCell>
                    <CTableHeaderCell>{t('secondColumn') || 'Ikinci Sutun'}</CTableHeaderCell>
                    <CTableHeaderCell>{t('factor') || 'Carpan'}</CTableHeaderCell>
                    <CTableHeaderCell style={{ width: '90px' }}>{t('action') || 'Islem'}</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {weaveFactorRows.map((row) => (
                    <CTableRow key={row.localId}>
                      <CTableDataCell>
                        <CFormInput
                          value={row.firstColon}
                          onChange={(e) => handleWeaveFactorInputChange(row.localId, 'firstColon', e.target.value)}
                          placeholder="0"
                        />
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput
                          value={row.secondColon}
                          onChange={(e) => handleWeaveFactorInputChange(row.localId, 'secondColon', e.target.value)}
                          placeholder="0"
                        />
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput
                          value={row.factor}
                          onChange={(e) => handleWeaveFactorInputChange(row.localId, 'factor', e.target.value)}
                          placeholder="0"
                        />
                      </CTableDataCell>
                      <CTableDataCell className="text-center align-middle">
                        <CButton
                          color="danger"
                          variant="outline"
                          size="sm"
                          className="d-inline-flex align-items-center justify-content-center p-0"
                          style={{ width: '28px', height: '28px' }}
                          onClick={() => handleRemoveWeaveFactorRow(row.localId)}
                        >
                          <CIcon icon={cilMinus} size="sm" />
                        </CButton>
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={handleCloseWeaveFactorModal}>
              <CIcon icon={cilX} className="me-1" /> {t('cancel') || 'Iptal'}
            </CButton>
            <CButton color="primary" onClick={handleSaveWeaveFactorModal}>
              <CIcon icon={cilSave} className="me-1" /> {t('save') || 'Kaydet'}
            </CButton>
          </CModalFooter>
        </CModal>
      </CForm>
    </div>
  );
};

WeaveInputs.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  submitResponse: PropTypes.object,
  initialData: PropTypes.object,
  isEdit: PropTypes.bool,
};

export default WeaveInputs;
